import { loadReportFields } from 'assets/js/SelectizePlugin-InfiniteScroll';

export function loadReportBuilder(passedScope, $q, $location, $rootScope, $http, reportBuilderService, logService) {
    var $builder,
        $reportTemplate,
        $inspectionTemplateCommonFields,

        _builder,
        _logUsers,
        _filterCache = {},
        _filterOptionsCache = {},
        _defaultFiltersArray,
        _templateSegmentCache = {},
        _reportLoaded = false,
        _reportTemplateDropdownHTML,
        _viewOnlyMode = false,
        _userConfirmedLeave = false,
        _initializationPromise = $q.defer(),
        _confirmationDefer = $q.defer(), // For awaiting dialog confirmations
        _topLevelMoveUpGroupClicked = false,
        _beforeDragGroupAndIndex = {},
        _defaultBasicNoteTemplateId,
        _logChangeStartSubscription = null,

        // scope object injected into parent angular controller
        $scope = passedScope,

        _defaultFieldFilters = {
            'Template': {
                id: 'template',
                label: 'Template',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'template' },
                input: function(rule, name) {
                    var html = getRuleValueContainer(rule, name);

                    html = $(html)
                        .find('.is-template > select')
                        .html(_reportTemplateDropdownHTML)
                        .end()
                        .prop('outerHTML');

                    return html;
                },
                operators: ['basic-notes-template', 'inspection-only-template', 'operational-only-template', 'is-template', 'includes-any-of-template', 'excludes-all-of-template'],
                default_operator: 'includes-any-of-template',
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'basic-notes-template':
                        case 'inspection-only-template':
                        case 'operational-only-template':
                            return rule.operator.type;
                        case 'is-template':
                            var $selectedOption = rule.$el.find('.rule-value-container .is-template option:selected');

                            return {
                                templateId: $selectedOption.val(),
                                subTemplateId: $selectedOption.data('logbook-subtemplate-id')
                            };
                        case 'includes-any-of-template':
                        case 'excludes-all-of-template':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function(a, b) {
                                if (a === 'Basic Note') return -1;
                                else if (b === 'Basic Note') return 1;
                                else return a - b;
                            });
                    }
                },
                valueSetter: function(rule, value) {
                    var $valueInput = rule.$el.find('.rule-value-container .' + rule.operator.type + ' > :input');

                    if (['includes-any-of-template', 'excludes-all-of-template'].indexOf(rule.operator.type) != -1) {
                        rule.filter.data.getTemplates.finally(function() {
                            $valueInput[0].selectize.setValue(value);

                            $scope.updateChangeStatus(false);
                        });
                    }
                    else if (rule.operator.type == 'is-template') {
                        if (value.subTemplateId) {
                            $valueInput
                                .find('option[data-logbook-subtemplate-id="' + value.subTemplateId + '"]')
                                .prop('selected', true);
                        }
                        else
                            $valueInput.val(value.templateId);
                    }
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Note': {
                id: 'note',
                label: 'Note',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note' },
                input: getRuleValueContainer,
                operators: ['has-abnormal-choices-note', 'not-has-abnormal-choices-note', 'has-out-of-range-note', 'not-has-out-of-range-note', 'has-pending-signoffs-note', 'not-has-pending-signoffs-note', 'has-pending-signoffs-users-note', 'has-rejected-signoffs-note', 'not-has-rejected-signoffs-note'],
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'has-abnormal-choices-note':
                        case 'not-has-abnormal-choices-note':
                            return rule.operator.type === 'has-abnormal-choices-note';
                        case 'has-out-of-range-note':
                        case 'not-has-out-of-range-note':
                            return rule.operator.type === 'has-out-of-range-note';
                        case 'has-pending-signoffs-note':
                        case 'not-has-pending-signoffs-note':
                        case 'has-rejected-signoffs-note':
                        case 'not-has-rejected-signoffs-note':
                            return rule.operator.type === 'has-pending-signoffs-note' || rule.operator.type === 'not-has-rejected-signoffs-note';
                        case 'has-pending-signoffs-users-note':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function (a, b) {
                                if (a === 'current') return -1;
                                else if (b === 'current') return 1;
                                else return a - b;
                            });
                    }
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.type === 'has-pending-signoffs-users-note')
                        rule.filter.data.getLogBookUsers.done(function() {
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value);
                            $scope.updateChangeStatus(false);
                        });
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Note Timeframe': {
                id: 'note-timeframe',
                label: 'Note Timeframe',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note-date-time' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['specific-date', 'date-range', 'time-range'],
                default_operator: 'date-range',
                valueGetter: reportBuilderService.noteTimeframe.valueGetter,
                valueSetter: reportBuilderService.noteTimeframe.valueSetter,
                validation: {
                    allow_empty_value: true,
                    callback: reportBuilderService.validateDateTime
                }
            },
            'Note Date Time': {
                id: 'note-date-time',
                label: 'Note Date/Time',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note-date-time' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['specific-date', 'date-range', 'time-range'],
                default_operator: 'date-range',
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'specific-date':
                        case 'date-range':
                        case 'time-range':
                            var values = [];
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                .closest('div')
                                .find(':input')
                                .each(function() {
                                    values.push(this.value);
                                });
                            return values;
                        default:
                            return checkInspectionSegmentSettings(rule);
                    }
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.type === 'specific-date' || rule.operator.type === 'date-range' || rule.operator.type === 'time-range') {
                        rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');

                        if (value.length > 1) {
                            var inputs = rule.$el
                                .find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                .closest('div')
                                .find(':input, select');

                            for (var i = 1; i < inputs.length; i++) {
                                $(inputs[i]).val(value[i]);
                            }
                        }
                    }
                },
                validation: {
                    allow_empty_value: true,
                    callback: validateDateTime
                }
            },
            'Update Date Time': {
                id: 'update-date-time',
                label: 'Update Date/Time',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note-date-time' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['specific-date', 'date-range', 'time-range'],
                default_operator: 'date-range',
                valueGetter: function(rule) {
                    var values = [];
                    rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked')
                        .closest('div')
                        .find(':input')
                        .each(function() {
                            values.push(this.value);
                        });
                    return values;
                },
                valueSetter: function(rule, value) {
                    rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');

                    if (value.length > 1) {
                        var inputs = rule.$el
                            .find('.rule-value-container .' + rule.operator.type + ' input:checked')
                            .closest('div')
                            .find(':input, select');

                        for (var i = 1; i < inputs.length; i++) {
                            $(inputs[i]).val(value[i]);
                        }
                    }
                },
                validation: {
                    allow_empty_value: true,
                    callback: validateDateTime
                }
            },
            'Note Creation Date Time': {
                id: 'note-creation-date-time',
                label: 'Note Creation Date/Time',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note-date-time' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['specific-date', 'date-range', 'time-range'],
                default_operator: 'date-range',
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'specific-date':
                        case 'date-range':
                        case 'time-range':
                            var values = [];
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                .closest('div')
                                .find(':input')
                                .each(function() {
                                    values.push(this.value);
                                });
                            return values;
                        default:
                            return checkInspectionSegmentSettings(rule);
                    }
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.type === 'specific-date' || rule.operator.type === 'date-range' || rule.operator.type === 'time-range') {
                        rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');

                        if (value.length > 1) {
                            var inputs = rule.$el
                                .find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                .closest('div')
                                .find(':input, select');

                            for (var i = 1; i < inputs.length; i++) {
                                $(inputs[i]).val(value[i]);
                            }
                        }
                    }
                },
                validation: {
                    allow_empty_value: true,
                    callback: validateDateTime
                }
            },
            'Tags': {
                id: 'tags',
                label: 'Tags',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'tags' },
                input: getRuleValueContainer,
                operators: ['any-tags', 'none-tags', 'includes-all-of-tags', 'includes-any-of-tags', 'missing-all-of-tags', 'missing-any-of-tags'],
                default_operator: 'includes-any-of-tags',
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'any-tags':
                        case 'none-tags':
                            return rule.operator.type === 'any-tags';
                        case 'includes-all-of-tags':
                        case 'includes-any-of-tags':
                        case 'missing-all-of-tags':
                        case 'missing-any-of-tags':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',');
                        default:
                            return checkInspectionSegmentSettings(rule);
                    }
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.type === 'includes-all-of-tags' || rule.operator.type === 'includes-any-of-tags' ||
                        rule.operator.type === 'missing-all-of-tags' || rule.operator.type === 'missing-any-of-tags')
                        rule.filter.data.getTagValues.done(function() {
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value.sort());
                            $scope.updateChangeStatus(false);
                        });
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Note Contents': {
                id: 'note-contents',
                label: 'Note Contents',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'note-contents' },
                input: getRuleValueContainer,
                operators: ['contains-note-contents', 'not-contains-note-contents'],
                valueGetter: function(rule) {
                    var text = rule.$el.find('.rule-value-container .' + rule.operator.type + ' input').val(),
                        settings = rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input');

                    var settingsJSON = {
                        'case-sensitive': settings[0].checked,
                        'whole-word': settings[1].checked,
                        'wildcards': settings[2].checked
                    };

                    return [text, settingsJSON];
                },
                valueSetter: function(rule, value) {
                    $(rule.$el.find('.rule-value-container .' + rule.operator.type + ' input')[0]).val(value[0]);
                    rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[0].checked = value[1]['case-sensitive'];
                    rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[1].checked = value[1]['whole-word'];
                    rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[2].checked = value[1]['wildcards'];
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Created By': {
                id: 'created-by',
                label: 'Created By',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'users' },
                input: getRuleValueContainer,
                operators: ['includes-any-of-users', 'excludes-all-of-users'],
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'any-users':
                        case 'none-users':
                            return rule.operator.type === 'any-users';
                        case 'includes-any-of-users':
                        case 'excludes-all-of-users':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function(a, b) {
                                if (a === 'current') return -1;
                                else if (b === 'current') return 1;
                                else return a - b;
                            });
                        default:
                            return checkInspectionSegmentSettings(rule);
                    }
                },
                valueSetter: function(rule, value) {
                    if (rule.operator.type === 'includes-any-of-users' || rule.operator.type === 'excludes-all-of-users')
                        rule.filter.data.getLogBookUsers.done(function() {
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value);
                            $scope.updateChangeStatus(false);
                        });
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Updated By': {
                id: 'updated-by',
                label: 'Updated By',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'users' },
                input: getRuleValueContainer,
                operators: ['includes-any-of-users', 'excludes-all-of-users'],
                valueGetter: function(rule) {
                    return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function(a, b) {
                        if (a === 'current') return -1;
                        else if (b === 'current') return 1;
                        else return a - b;
                    });
                },
                valueSetter: function(rule, value) {
                    rule.filter.data.getLogBookUsers.done(function() {
                        rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value);
                        $scope.updateChangeStatus(false);
                    });
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Turnover': {
                id: 'turnover',
                label: 'Turnover',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'turnover' },
                input: getRuleValueContainer,
                operators: ['only-turnover', 'all-turnover'],
                valueGetter: function(rule) {
                    return rule.operator.type === 'only-turnover';
                },
                validation: {
                    allow_empty_value: true
                }
            },
            'Carry Forward': {
                id: 'carry-forward',
                label: 'Carry Forward',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'carry-forward' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['is-carry-forward', 'not-carry-forward', 'all-carry-forward', 'active-carry-forward', 'ended-carry-forward',
                    'start-date-carry-forward', 'start-date-range-carry-forward', 'start-time-range-carry-forward',
                    'end-date-carry-forward', 'end-date-range-carry-forward', 'end-time-range-carry-forward'],
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'is-carry-forward':
                        case 'not-carry-forward':
                        case 'all-carry-forward':
                        case 'active-carry-forward':
                        case 'ended-carry-forward':
                            return rule.operator.type === 'is-carry-forward' || rule.operator.type === 'active-carry-forward' ? true :
                                rule.operator.type === 'all-carry-forward' ? null : false;
                        case 'start-date-carry-forward':
                        case 'start-date-range-carry-forward':
                        case 'start-time-range-carry-forward':
                        case 'end-date-carry-forward':
                        case 'end-date-range-carry-forward':
                        case 'end-time-range-carry-forward':
                            var values = [];
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                .closest('div')
                                .find(':input')
                                .each(function() {
                                    values.push(this.value);
                                });
                            return values;
                    }
                },
                valueSetter: function(rule, value) {
                    switch (rule.operator.type) {
                        case 'start-date-carry-forward':
                        case 'start-date-range-carry-forward':
                        case 'start-time-range-carry-forward':
                        case 'end-date-carry-forward':
                        case 'end-date-range-carry-forward':
                        case 'end-time-range-carry-forward':
                            rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');
                            if (value.length > 1) {
                                var inputs = rule.$el
                                    .find('.rule-value-container .' + rule.operator.type + ' input:checked')
                                    .closest('div')
                                    .find(':input, select');
                                for (var i = 1; i < inputs.length; i++) {
                                    $(inputs[i]).val(value[i]);
                                }
                            }
                            break;
                    }
                },
                validation: {
                    allow_empty_value: true,
                    callback: function(value, rule) {
                        if (rule.operator.type === 'start-date-carry-forward' || rule.operator.type === 'start-date-range-carry-forward' || rule.operator.type === 'start-time-range-carry-forward' ||
                            rule.operator.type === 'end-date-carry-forward' || rule.operator.type === 'end-date-range-carry-forward' || rule.operator.type === 'end-time-range-carry-forward')
                            validateDateTime(value);

                        return true;
                    }
                }
            },
            'Attachments': {
                id: 'attachments',
                label: 'Attachments',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'attachments' },
                input: getRuleValueContainer,
                operators: ['any-attachments', 'none-attachments', 'filename-attachments', 'extension-attachments', 'number-attachments'],
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'any-attachments':
                        case 'none-attachments':
                            return rule.operator.type === 'any-attachments';
                        case 'filename-attachments':
                        case 'extension-attachments':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' input').val();
                        case 'number-attachments':
                            var comparison = rule.$el.find('.rule-value-container .number-attachments select').val(),
                                value = rule.$el.find('.rule-value-container .number-attachments input').val();
                            return [comparison, value];
                        default:
                            return checkInspectionSegmentSettings(rule);
                    }
                },
                valueSetter: function(rule, value) {
                    switch (rule.operator.type) {
                        case 'filename-attachments':
                        case 'extension-attachments':
                            $(rule.$el.find('.rule-value-container .' + rule.operator.type + ' input')[0]).val(value);
                            break;
                        case 'number-attachments':
                            $(rule.$el.find('.rule-value-container .number-attachments select')[0]).val(value[0]);
                            $(rule.$el.find('.rule-value-container .number-attachments input')[0]).val(value[1]);
                            break;
                    }
                },
                validation: {
                    allow_empty_value: true,
                    callback: function(value, rule) {
                        var moreThan, lessThan;

                        for (var i = 0; i < value.length; i++) {
                            switch (value[i][0]) {
                                case "More Than":
                                    value[i][1] = parseInt(value[i][1], 10);
                                    moreThan = value[i][1];
                                    break;
                                case "Less Than":
                                    value[i][1] = parseInt(value[i][1], 10);
                                    lessThan = value[i][1];
                                    break;
                                case "Exactly":
                                    value[i][1] = parseInt(value[i][1], 10);
                                    break;
                            }
                        }

                        if (!isNaN(moreThan) && !isNaN(lessThan) && ((rule.operator.type === 'have' && (lessThan - moreThan < 2)) || (rule.operator.type === 'dont-have' && lessThan >= moreThan)))
                            return "More Than and Less Than must create a valid range";

                        return true;
                    }
                }
            },
            'Comments': {
                id: 'comments',
                label: 'Comments',
                optgroup: 'Default Fields',
                data: { htmlTemplateId: 'comments' },
                input: getRuleValueContainer,
                input_event: 'dp.change',
                operators: ['any-comments', 'none-comments', 'contains-comments', 'not-contains-comments', 'made-by-comments', 'not-made-by-comments', 'time-added-comments'],
                default_operator: 'contains-comments',
                valueGetter: function(rule) {
                    switch (rule.operator.type) {
                        case 'any-comments':
                        case 'none-comments':
                            return rule.operator.type === 'any-comments';
                        case 'contains-comments':
                        case 'not-contains-comments':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' input').val();
                        case 'made-by-comments':
                        case 'not-made-by-comments':
                            return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function(a, b) {
                                if (a === 'current') return -1;
                                else if (b === 'current') return 1;
                                else return a - b;
                            });
                        case 'time-added-comments':
                            var values = [];
                            rule.$el.find('.rule-value-container .time-added-comments input').each(function() {
                                values.push(this.value);
                            });
                            return values;
                    }
                },
                valueSetter: function(rule, value) {
                    switch (rule.operator.type) {
                        case 'contains-comments':
                        case 'not-contains-comments':
                            $(rule.$el.find('.rule-value-container .' + rule.operator.type + ' input')[0]).val(value);
                            break;
                        case 'made-by-comments':
                        case 'not-made-by-comments':
                            rule.filter.data.getLogBookUsers.done(function() {
                                rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value);
                                $scope.updateChangeStatus(false);
                            });
                            break;
                        case 'time-added-comments':
                            var inputs = rule.$el.find('.rule-value-container .time-added-comments input');
                            $(inputs[0]).val(value[0]);
                            $(inputs[1]).val(value[1]);
                            break;
                    }
                },
                validation: {
                    allow_empty_values: true,
                    callback: function(value, rule) {
                        if (rule.operator.type === 'time-added-comments') {
                            if (Date.parse(value[0]) > Date.parse(value[1])) {
                                var x = value[0];
                                value[0] = value[1];
                                value[1] = x;
                            }
                        }

                        return true;
                    }
                }
            }
        },

        _defaultFiltersArray = $.map(_defaultFieldFilters, function(filter) {
            return filter;
        }),

    	_templateSegmentFilters = {
			'Text Input': {
				htmlTemplateId: 'lb-text-input-template-segment',
				operators: ['any-text-input', 'none-text-input', 'contains-text-input', 'not-contains-text-input'],
            default_operator: 'contains-text-input',
				valueGetter: function(rule) {
					switch (rule.operator.type) {
						case 'any-text-input':
						case 'none-text-input':
							return rule.operator.type === 'any-text-input';
						case 'contains-text-input':
						case 'not-contains-text-input':
							var text = rule.$el.find('.rule-value-container .' + rule.operator.type + ' input').val(),
								settings = rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input');

							var settingsJSON = {
								'case-sensitive': settings[0].checked,
								'whole-word': settings[1].checked,
								'wildcards': settings[2].checked
							};

							return [text, settingsJSON];
						default:
							return checkInspectionSegmentSettings(rule);
					}
				},
				valueSetter: function(rule, value) {
					if (rule.operator.type === 'contains-text-input' || rule.operator.type === 'not-contains-text-input') {
						$(rule.$el.find('.rule-value-container .' + rule.operator.type + ' input')[0]).val(value[0]);
						rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[0].checked = value[1]['case-sensitive'];
						rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[1].checked = value[1]['whole-word'];
						rule.$el.find('.rule-value-container .' + rule.operator.type + ' > label > input')[2].checked = value[1]['wildcards'];
					}
				},
				validation: {
					allow_empty_value: true
				}
			},
			'Numeric Input': {
				htmlTemplateId: 'lb-numeric-template-segment',
				operators: ['any-numeric', 'none-numeric', 'is-numeric', 'out-of-range', 'not-out-of-range'],
            default_operator: 'is-numeric',
				valueGetter: function(rule) {
					switch (rule.operator.type) {
						case 'any-numeric':
						case 'none-numeric':
							return rule.operator.type === 'any-numeric';
						case 'is-numeric':
							var comparison = rule.$el.find('.rule-value-container .is-numeric select').val(),
								value = rule.$el.find('.rule-value-container .is-numeric input').val();
							return [comparison, value];
						case 'out-of-range':
						case 'not-out-of-range':
							return rule.operator.type === 'out-of-range';
						default:
							return checkInspectionSegmentSettings(rule);
					}
				},
				valueSetter: function(rule, value) {
					if (rule.operator.type === 'is-numeric') {
						$(rule.$el.find('.rule-value-container .is-numeric select')[0]).val(value[0]);
						$(rule.$el.find('.rule-value-container .is-numeric input')[0]).val(value[1]);
					}
				},
				validation: {
					allow_empty_value: true
				}
			},
			'Checkbox': {
				htmlTemplateId: 'lb-checkbox-template-segment',
				operators: ['is-checkbox'],
				valueGetter: function(rule) {
					if (rule.operator.type === 'is-checkbox')
						return rule.$el.find('.rule-value-container .is-checkbox select').val();
					else
						return checkInspectionSegmentSettings(rule);
				},
				valueSetter: function(rule, value) {
					if (rule.operator.type === 'is-checkbox')
						$(rule.$el.find('.rule-value-container .is-checkbox select')[0]).val(value);
				},
				validation: {
					allow_empty_value: true
				}
			},
			'Date/Time': {
				'Date And Time': {
					htmlTemplateId: 'note-date-time',
					operators: ['specific-date', 'date-range', 'time-range'],
                default_operator: 'date-range',
					input_event: 'dp.change',
					valueGetter: _defaultFieldFilters['Note Date Time'].valueGetter,
					valueSetter: _defaultFieldFilters['Note Date Time'].valueSetter,
					validation: _defaultFieldFilters['Note Date Time'].validation
				},
				'Date Only': {
					htmlTemplateId: 'note-date-time',
					operators: ['specific-date', 'date-range'],
                default_operator: 'date-range',
					input_event: 'dp.change',
					valueGetter: _defaultFieldFilters['Note Date Time'].valueGetter,
					valueSetter: _defaultFieldFilters['Note Date Time'].valueSetter,
					validation: _defaultFieldFilters['Note Date Time'].validation
				},
				'Time Only': {
					htmlTemplateId: 'lb-dt-time-only-template-segment',
					operators: ['time-range'],
					input_event: 'dp.change',
					valueGetter: function(rule) {
						switch (rule.operator.type) {
							case 'time-range':
								var values = [];
								rule.$el.find('.rule-value-container .time-range input').each(function() {
									values.push(this.value);
								});
								return values;
							default:
								return checkInspectionSegmentSettings(rule);
						}
					},
					valueSetter: function(rule, value) {
						if (rule.operator.type === 'time-range') {
							var inputs = rule.$el.find('.rule-value-container .time-range input');
							$(inputs[0]).val(value[0]);
							$(inputs[1]).val(value[1]);
						}
					},
					validation: {
						allow_empty_value: true,
						callback: function(value, rule) {
							var start = moment(value[0], "H:mm"),
								end = moment(value[1], "H:mm");

							if (end.isBefore(start)) {
								var x = value[0];
								value[0] = value[1];
								value[1] = x;
							}

							return true;
						}
					}
				}
			},
			'Text Choice': {
				htmlTemplateId: 'lb-text-choice-template-segment',
				operators: ['any-text-choice', 'none-text-choice', 'includes-any-of-text-choice', 'missing-all-of-text-choice', 'abnormal-choice', 'not-abnormal-choice'],
            default_operator: 'includes-any-of-text-choice',
				valueGetter: function(rule) {
					switch (rule.operator.type) {
						case 'any-text-choice':
						case 'none-text-choice':
							return rule.operator.type === 'any-text-choice';
						case 'includes-any-of-text-choice':
						case 'missing-all-of-text-choice':
							return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',');
						case 'abnormal-choice':
						case 'not-abnormal-choice':
							return rule.operator.type === 'abnormal-choice';
						default:
							return checkInspectionSegmentSettings(rule);
					}
				},
				valueSetter: function(rule, value) {
					if (rule.operator.type === 'includes-any-of-text-choice' || rule.operator.type === 'missing-all-of-text-choice')
						rule.filter.data.getChoiceListItems.done(function() {
							rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value.sort());
							$scope.updateChangeStatus(false);
						});
				},
				validation: {
					allow_empty_value: true
				}
			},
			'Tag Choice': {
				htmlTemplateId: 'tags',
				operators: ['any-tags', 'none-tags', 'includes-all-of-tags', 'includes-any-of-tags', 'missing-all-of-tags', 'missing-any-of-tags'],
            default_operator: 'includes-any-of-tags',
				valueGetter: _defaultFieldFilters['Tags'].valueGetter,
				valueSetter: _defaultFieldFilters['Tags'].valueSetter,
				validation: _defaultFieldFilters['Tags'].validation
			},
			'Signoff': {
				htmlTemplateId: 'lb-signoff-template-segment',
				operators: ['any-signoff', 'none-signoff', 'pending-includes-any-of-signoff', 'includes-any-of-signoff', 'excludes-all-of-signoff', 'specific-date-signoff', 'date-range-signoff', 'time-range-signoff', 'rejected-signoff', 'not-rejected-signoff'],
            	default_operator: 'includes-any-of-signoff',
				input_event: 'dp.change',
				valueGetter: function(rule) {
					switch (rule.operator.type) {
						case 'any-signoff':
						case 'none-signoff':
							return rule.operator.type === 'any-signoff';
						case 'pending-includes-any-of-signoff':
						case 'includes-any-of-signoff':
						case 'excludes-all-of-signoff':
							return rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input').val().split(',').sort(function(a, b) {
								if (a === 'current') return -1;
								else if (b === 'current') return 1;
								else return a - b;
							});
						case 'specific-date-signoff':
						case 'date-range-signoff':
						case 'time-range-signoff':
							var values = [];
							rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked')
								.closest('div')
								.find(':input')
								.each(function() {
									values.push(this.value);
								});
							return values;
						case 'rejected-signoff':
						case 'not-rejected-signoff':
							return rule.operator.type === 'not-rejected-signoff';
					}
				},
				valueSetter: function(rule, value) {
					switch (rule.operator.type) {
							case 'pending-includes-any-of-signoff':
						case 'includes-any-of-signoff':
						case 'excludes-all-of-signoff':
							rule.filter.data.getLogBookUsers.done(function() {
								rule.$el.find('.rule-value-container .' + rule.operator.type + ' > input')[0].selectize.setValue(value);
								$scope.updateChangeStatus(false);
							});
							break;
						case 'specific-date-signoff':
						case 'date-range-signoff':
						case 'time-range-signoff':
							rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');
							if (value.length > 1) {
								var inputs = rule.$el
									.find('.rule-value-container .' + rule.operator.type + ' input:checked')
									.closest('div')
									.find(':input, select');
								for (var i = 1; i < inputs.length; i++) {
									$(inputs[i]).val(value[i]);
								}
							}
							break;
					}
				},
				validation: {
					allow_empty_value: true,
					callback: function(value, rule) {
						if (rule.operator.type === 'specific-date-signoff' || rule.operator.type === 'date-range-signoff' || rule.operator.type === 'time-range-signoff')
							validateDateTime(value);

						return true;
					}
				}
			},
			'File Attachment': {
				htmlTemplateId: 'attachments',
				operators: ['any-attachments', 'none-attachments', 'filename-attachments', 'extension-attachments', 'number-attachments'],
            default_operator: 'filename-attachments',
				valueGetter: _defaultFieldFilters['Attachments'].valueGetter,
				valueSetter: _defaultFieldFilters['Attachments'].valueSetter,
				validation: _defaultFieldFilters['Attachments'].validation
			},
			'User Chooser': {
				htmlTemplateId: 'users',
				operators: ['any-users', 'none-users', 'includes-any-of-users', 'excludes-all-of-users'],
            default_operator: 'includes-any-of-users',
				valueGetter: _defaultFieldFilters['Created By'].valueGetter,
				valueSetter: _defaultFieldFilters['Created By'].valueSetter,
				validation: _defaultFieldFilters['Created By'].validation
			}
		};

    function initialize() {
        _confirmationDefer.resolve();

        var $fieldsInUseWarning = $('#fields-in-use-warning'),
            $unsavedChangesModal = $('#unsaved-changes-modal');

        $reportTemplate = $('#report-template');
        $inspectionTemplateCommonFields = $('#inspection-template-common-fields');
        $builder = $('#builder');

        // $document = $(document);

        $scope.getTemplateIds = function() {
            return $scope.templates.map(function(template) { return template.id })
        };

        $scope.getSubTemplateIds = function() {
            return $scope.templates
                .filter(function(template) { return template.subTemplates.length })
                .map(function(template) { return template.subTemplates })
                .reduce(function(array, val) { return array.concat(val) }, [])
                .map(function(subTemplate) { return subTemplate.id });
        };

        $builder.on('rulesChanged.queryBuilder afterCreateRuleFilters.queryBuilder afterUpdateRuleFilter.queryBuilder \
            change:not(.select-rule) .allow-config .filter-operator-wrapper .runtime-label', function(node, error, value) {
            $scope.updateChangeStatus(true);
        })
        $builder.on('afterCreateRuleInput.queryBuilder', function(e, rule) {
            initializePlugins(e, rule);

            if (_viewOnlyMode) {
                rule.$el.find(':input').attr('tabindex', -1).end()
                    .children(':gt(2)').addClass('values-disabled');
            }
        })
        .on('afterCreateRuleFilters.queryBuilder', function(e, rule) {
            rule.$el
                .find('.rule-filter-container > select')
                .attr('class', 'selectpicker')
                .selectpicker({
                    liveSearch: true,
                    width: 'fit'
                })
                .on('shown.bs.select', function(e) {
                    var listIems = $(this).data('selectpicker').selectpicker.current.elements;

                    listIems.forEach(function(li) {
                        var overflowed = li.firstChild && li.firstChild.scrollWidth > li.firstChild.clientWidth;

                        // Show bootstrap tooltip with full name on hover (and other possible events) of overflowed element
                        if (overflowed)
                            $(li).attr('title', li.textContent).tooltip();
                    });
                });
        })
        $builder.on('afterUpdateRuleFilter.queryBuilder', function(e, rule, previousFilter) {
            rule.data = rule.data || { };
            rule.$el.find('.rule-filter-container select').selectpicker('render');

            rule.error = null;

            // All but empty placeholder rule
            if (rule.filter) {
                var tooltip = rule.filter.optgroup;
                if (tooltip === 'Default Fields')
                    tooltip = 'Default Field';

                // Could use bootstrap tooltip here as well, tricky to configure though
                rule.$el.find('.rule-filter-container > .bootstrap-select > button').attr('title', tooltip);

                if (previousFilter && previousFilter.id == 'template' && rule.parent.data.templateConstraint) {
                    var templateConstraintRoot = getRootANDGroup(rule.parent);
                    
                    delete templateConstraintRoot.data.templateConstraint;

                    removeTemplateRules(templateConstraintRoot);
                    refreshTemplateConstraints(templateConstraintRoot);
                }
            }

            if (_reportLoaded && event && $(event.target).hasClass('selectpicker')) {
                rule.$el.find('.runtime-label').val('');

                setRuntimeState(rule);
            }
        })
        $builder.on('afterCreateRuleOperators.queryBuilder', function(e, rule) {
            rule.$el
                .find('.rule-operator-container > select')
                .attr('class', 'selectpicker')
                .selectpicker({ width: 'auto' });
        })

        $builder.on('afterUpdateRuleOperator.queryBuilder', function(e, rule, previousOperator) {
            rule.$el.find('.rule-operator-container select').selectpicker('render');

            var $operatorTemplates = rule.$el.find('.rule-value-container > div > div');

            $operatorTemplates.each(function() {
                $(this).toggleClass('hide', !$(this).hasClass(rule.operator.type));
            });

            setRuntimeState(rule);

            if (rule.data.skipConstraintUpdate)
                delete rule.data.skipConstraintUpdate;
            else if (rule.parent.condition == 'AND' && _reportLoaded) {
                if (rule.operator.type == 'is-template') {
                    var templateConstraintRoot = getRootANDGroup(rule),
                        templateRuleCount = getTemplateRuleCount(templateConstraintRoot);

                    if (templateRuleCount > 1) {
                        alert('A template-constrained group or group hierarchy cannot contain more than one template rule.')
                        
                        // Prevents this handler's template logic from executing a second time after operator is set to the previous operator
                        rule.data.skipConstraintUpdate = true;
                        rule.operator = previousOperator;

                        return;
                    }
                    
                    addOrUpdateTemplateConstraints(templateConstraintRoot);
                }
                else if (previousOperator.type == 'is-template') {
                    var templateConstraintRoot = getRootANDGroup(rule);

                    delete templateConstraintRoot.data.templateConstraint;

                    removeTemplateRules(templateConstraintRoot);
                    refreshTemplateConstraints(templateConstraintRoot);
                }
            }
        })

        $builder.on('afterAddGroup.queryBuilder', function(e, group) {
            if (!group.data)
                group.data = {};

            if (!group.parent)
                return;
            
            group.parent.error = null;
            
            if (group.parent.data.templateConstraint)
                group.data.templateConstraint = group.parent.data.templateConstraint;

            group.$el.children().first().find('.condition').text(group.parent.condition);
            group.condition = group.parent.condition == 'AND' ? 'OR' : 'AND';
            
            var rulesToMove = getSelectedRules(group.parent, _topLevelMoveUpGroupClicked);

            if (!rulesToMove.length)
                return;
            
            if ($reportTemplate.val() == 'Default (All Notes)' && rulesToMove.some(function(rule) {
                    return rule.operator && rule.operator.type == 'is-template';
                })) {
                if (group.condition == 'AND') {
                    var templateRules = rulesToMove.filter(function(rule) {
                        return rule.filter && rule.filter.id == 'template';
                    });

                    if (templateRules.length > 1) {
                        alert('You cannot move any other template rules into an AND group when moving a "Template Is" rule.')
                        return;
                    }

                    moveSelectedRules(group, rulesToMove);
                    addOrUpdateTemplateConstraints(group);
                }
                else {
                    moveSelectedRules(group, rulesToMove);

                    var templateConstraintRoot = getTemplateConstraintRootGroup(group);

                    delete templateConstraintRoot.data.templateConstraint;

                    removeTemplateRules(templateConstraintRoot);
                    refreshTemplateConstraints(templateConstraintRoot);
                }
            }
            else
                moveSelectedRules(group, rulesToMove);
        })
        .on('afterUpdateGroupCondition.queryBuilder', function(e, group, previousCondition) {
            group.rules.forEach(function(rule) {
                rule.$el.children().first().find('.condition').text(group.condition);
            });
        })
        .on('afterAddRule.queryBuilder', function(e, rule) {
            rule.parent.error = null;

            rule.$el.children().first().find('.condition').text(rule.parent.condition);

            if (!rule.data)
                rule.data = {};
            
            if (_reportLoaded)
                toggleGroupButtons(rule.parent);
        })
        .on('beforeDeleteRule.queryBuilder', function(e, rule) {
            var htmlTemplateId = rule.data.htmlTemplateId;
            
            if (!htmlTemplateId)
                htmlTemplateId = rule.filter ? rule.filter.data.htmlTemplateId : null;

            if (htmlTemplateId == 'template' && rule.parent.data.templateConstraint) {
                var templateConstraintRoot = getRootANDGroup(rule);

                delete templateConstraintRoot.data.templateConstraint;

                removeTemplateRules(templateConstraintRoot);
                refreshTemplateConstraints(templateConstraintRoot);
            }

            toggleGroupButtons(rule.parent, rule);
        });

        $builder.on('afterMove.queryBuilder', function(e, node) {
            var resetControls = function() {
                if (!node.condition) {
                    var $checkbox = node.$el.find('.select-rule');

                    if ($checkbox.prop('checked')) {
                        $checkbox.prop('checked', false);

                        toggleGroupButtons(_beforeDragGroupAndIndex.group);
                    }
                }

                node.$el.children().first().find('.condition').text(node.parent.condition);
            };

            if ($reportTemplate.val() == 'Default (All Notes)') {
                if (node.parent == _beforeDragGroupAndIndex.group)
                    return;
                
                var cancelMove = function() {
                    node.move(_beforeDragGroupAndIndex.group, _beforeDragGroupAndIndex.index);
                };

                if (node.condition) {
                    if (node.parent.data.templateConstraint) {
                        var templateConstraintRoot = getTemplateConstraintRootGroup(node),
                            templateRuleCount = getTemplateRuleCount(templateConstraintRoot);

                        if (templateRuleCount > 1) {
                            alert('A template-constrained group or group hierarchy cannot contain more than one template rule.')
                            cancelMove();
                            return;
                        }
                        
                        if (node.data.templateConstraint != node.parent.data.templateConstraint) {
                            node.data.templateConstraint = node.parent.data.templateConstraint;
                        
                            removeTemplateRules(node);
                            refreshTemplateConstraints(node);
                        }
                    }
                    else if (node.data.templateConstraint) {
                        var isTemplateConstraintRoot = node.rules.some(function(rule) {
                            return rule.data.htmlTemplateId == 'template';
                        });

                        if (isTemplateConstraintRoot)
                            addOrUpdateTemplateConstraints(getRootANDGroup(node), node);
                        else {
                            delete node.data.templateConstraint;

                            removeTemplateRules(node);
                            refreshTemplateConstraints(node);
                        }
                    }
                }
                else {
                    var moveToTemplateConstraint = node.parent.data.templateConstraint,
                        moveFromTemplateConstraint = _beforeDragGroupAndIndex.group.data.templateConstraint,
                        movedTemplateRule = node.filter && node.filter.id == 'template';

                    if (movedTemplateRule) {
                        var templateConstraintRoot = moveToTemplateConstraint ?
                            getTemplateConstraintRootGroup(node) :
                            getRootANDGroup(node);
                        
                        if (templateConstraintRoot &&
                            getIsTemplateRule(templateConstraintRoot) &&
                            getTemplateRuleCount(templateConstraintRoot) > 1) {
                                alert('A template-constrained group or group hierarchy cannot contain more than one template rule.')
                                cancelMove();
                                return;
                            }
                    }

                    var movedTemplateFieldRule = node.filter && node.filter.optgroup != 'Default Fields';

                    if (movedTemplateFieldRule && moveFromTemplateConstraint != moveToTemplateConstraint) {
                        alert("You can only move a template field rule into or within a group having the same template constraint.");
                        cancelMove();
                        return;
                    }

                    if (movedTemplateRule && node.operator.type == 'is-template') {
                        var movedToRootANDGroup = getRootANDGroup(node),
                            stopAtSubGroup;

                        if (moveFromTemplateConstraint) {
                            var movedFromRootANDGroup = getRootANDGroup(_beforeDragGroupAndIndex.group),
                                movedToSubGroup = _beforeDragGroupAndIndex.group.contains(node.parent, true);
                                movedToSuperGroup = !movedToSubGroup && node.parent.contains(_beforeDragGroupAndIndex.group, true);

                            if (movedToSuperGroup && node.parent.condition == 'AND')
                                stopAtSubGroup = movedFromRootANDGroup;
                            else {
                                if (movedToSubGroup)
                                    stopAtSubGroup = movedToRootANDGroup;
                            
                                if (movedFromRootANDGroup != stopAtSubGroup) {
                                    delete movedFromRootANDGroup.data.templateConstraint;
        
                                    removeTemplateRules(movedFromRootANDGroup, stopAtSubGroup);
                                    refreshTemplateConstraints(movedFromRootANDGroup, stopAtSubGroup);
                                }

                                if (movedToSubGroup) {
                                    resetControls();
                                    return;
                                }
                            }
                        }

                        if (node.parent.condition == 'AND' && movedToRootANDGroup != stopAtSubGroup)
                            addOrUpdateTemplateConstraints(movedToRootANDGroup, stopAtSubGroup);
                    }
                    else if (moveToTemplateConstraint || moveFromTemplateConstraint)
                        refreshFilterHTML(node);
                }
            }

            resetControls();
        })
        .on('getRuleFilters.queryBuilder.filter', function(e, rule) {
            // triggered when rule is first created and when $builder.queryBuilder('addFilter', ...) is called

            if ($reportTemplate.val() != 'Default (All Notes)')
                return;

            e.value = _defaultFiltersArray.slice(0);

            var templateConstraint = rule.parent.data.templateConstraint;

            if (templateConstraint) {
                // var htmlTemplateId = rule.data.htmlTemplateId || rule.filter.data.htmlTemplateId;
                var htmlTemplateId = rule.data.htmlTemplateId;

                if (!htmlTemplateId)
                    htmlTemplateId = rule.filter ? rule.filter.data.htmlTemplateId : null;

                if (htmlTemplateId != 'template') {
                    var templateFilters = _filterCache[templateConstraint];

                    Array.prototype.push.apply(e.value, templateFilters);
                }
            }
        })
        .on('getRuleFilterSelect.queryBuilder.filter', function(e, rule, filters) {
            // triggered when rule is first created and when $builder.queryBuilder('addFilter', ...) is called

            var templateConstraint = rule.parent.data.templateConstraint;

            if (templateConstraint) {
                var htmlTemplateId = rule.data.htmlTemplateId;
                
                if (!htmlTemplateId)
                    htmlTemplateId = rule.filter ? rule.filter.data.htmlTemplateId : null;

                if (htmlTemplateId != 'template') {
                    var html = $(e.value).find('option[value="template"]').remove().end().prop('outerHTML');

                    e.value = html;

                    if (!_filterOptionsCache[templateConstraint])
                        _filterOptionsCache[templateConstraint] = $(e.value).html();
                }
            }
        })
        .on('displayError.queryBuilder.filter', function(e, error, node) {
            if (node.condition) {
                node.$el.find('.error-container').html('<i class="glyphicon glyphicon-warning-sign"></i><span>A '
                    + (node.parent ? 'group' : 'report') + ' must have at least one field</span>');
            }
            else
                node.$el.find('.rule-value-container').html('<span class="error">You must select a search field</span>');
        });

        $builder.queryBuilder({
            allow_empty: true,
            select_placeholder: 'Select Search Field',
            display_empty_filter: true,
            operators: [
                // Template
                'basic-notes-template', 'inspection-only-template', 'operational-only-template', 'is-template',
                'includes-any-of-template', 'excludes-all-of-template',
                // Note
                'has-abnormal-choices-note', 'not-has-abnormal-choices-note',
                'has-out-of-range-note', 'not-has-out-of-range-note',
                'has-pending-signoffs-note', 'not-has-pending-signoffs-note',
                    'has-pending-signoffs-users-note',
                'has-rejected-signoffs-note', 'not-has-rejected-signoffs-note',
                // Date/Time
                'specific-date', 'date-range', 'time-range',
                // Tags
                'any-tags', 'none-tags',
                'includes-all-of-tags', 'includes-any-of-tags',
                'missing-all-of-tags', 'missing-any-of-tags',
                // Note Contents
                'contains-note-contents', 'not-contains-note-contents',
                // Users
                'any-users', 'none-users',
                'includes-any-of-users', 'excludes-all-of-users',
                // Turnover
                'only-turnover', 'all-turnover',
                // Carry Forward
                'is-carry-forward', 'not-carry-forward', 'all-carry-forward', 'active-carry-forward', 'ended-carry-forward',
                'start-date-carry-forward', 'start-date-range-carry-forward', 'start-time-range-carry-forward',
                'end-date-carry-forward', 'end-date-range-carry-forward', 'end-time-range-carry-forward',
                // Attachments
                'any-attachments', 'none-attachments',
                'filename-attachments', 'extension-attachments', 'number-attachments',
                // Comments
                'any-comments', 'none-comments',
                'contains-comments', 'not-contains-comments',
                'made-by-comments', 'not-made-by-comments',
                'time-added-comments',
                // Text Input
                'any-text-input', 'none-text-input',
                'contains-text-input', 'not-contains-text-input',
                // Numeric Input
                'any-numeric', 'none-numeric', 'is-numeric',
                'out-of-range', 'not-out-of-range',
                // Checkbox
                'is-checkbox',
                // Text Choice
                'any-text-choice', 'none-text-choice',
                'includes-any-of-text-choice', 'missing-all-of-text-choice',
                'abnormal-choice', 'not-abnormal-choice',
                // Signoff
                'any-signoff', 'none-signoff',
                'pending-includes-any-of-signoff', 'includes-any-of-signoff', 'excludes-all-of-signoff',
                'specific-date-signoff', 'date-range-signoff', 'time-range-signoff', 
                'rejected-signoff', 'not-rejected-signoff',
                // Inspection Segments
                'has-segment-comment', 'has-no-segment-comment',
                'has-segment-attachment', 'has-no-segment-attachment'
            ].map(function(operator) {
                return {
                    type: operator,
                    nb_inputs: 1,
                    apply_to: null,
                    multiple: true
                };
            }),
            lang: {
                add_rule: "New Field",
                add_group: "New Group",
                operators: {
                    // Template
                    'basic-notes-template': 'Basic Notes Only',
                    'inspection-only-template': 'Inspection Templates Only',
                    'operational-only-template': 'Operational Templates Only',
                    'is-template': 'Is',
                    'includes-any-of-template': 'Includes Any Of',
                    'excludes-all-of-template': 'Excludes All Of',
                    // Note
                    'has-abnormal-choices-note': 'Has Abnormal Choice(s)',
                    'not-has-abnormal-choices-note': 'Has No Abnormal Choices',
                    'has-out-of-range-note': 'Has Out-of-Range Value(s)',
                    'not-has-out-of-range-note': 'Has No Out-of-Range Values',
                    'has-pending-signoffs-note': 'Has Pending Signoff(s)',
                    'not-has-pending-signoffs-note': 'Has No Pending Signoffs',
                        'has-pending-signoffs-users-note': 'Has Pending Signoff For Any Of',
                    'has-rejected-signoffs-note': 'Has Rejected Signoff(s)', 
                    'not-has-rejected-signoffs-note': 'Has No Rejected Signoffs',
                    // Date/Time
                    'specific-date': 'Of a Specific Date',
                    'date-range': 'Within a Date Range',
                    'time-range': 'Within a Time Range',
                    // Tags
                    'any-tags': 'Has Any Tags',
                    'none-tags': 'Has No Tags',
                    'includes-all-of-tags': 'Includes All Of',
                    'includes-any-of-tags': 'Includes Any Of',
                    'missing-all-of-tags': 'Missing All Of',
                    'missing-any-of-tags': 'Missing Any Of',
                    // Note Contents
                    'contains-note-contents': 'Contain',
                    'not-contains-note-contents': 'Do Not Contain',
                    // Users
                    'any-users': 'Has A Value',
                    'none-users': 'Has No Value',
                    'includes-any-of-users': 'Includes Any Of',
                    'excludes-all-of-users': 'Excludes All Of',
                    // Turnover
                    'only-turnover': 'Only',
                    'all-turnover': 'Includes All',
                    // Carry Forward
                    'is-carry-forward': 'Only',
                    'not-carry-forward': 'Not Included',
                    'all-carry-forward': 'Includes All',
                    'active-carry-forward': 'Is Active',
                    'ended-carry-forward': 'Has Ended',
                    'start-date-carry-forward': 'Started On Date',
                    'start-date-range-carry-forward': 'Started In Date Range',
                    'start-time-range-carry-forward': 'Started In Time Range',
                    'end-date-carry-forward': 'Ends/Ended On Date',
                    'end-date-range-carry-forward': 'Ends/Ended In Date Range',
                    'end-time-range-carry-forward': 'Ends/Ended In Time Range',
                    // Attachments
                    'any-attachments': 'Has Any Attachments',
                    'none-attachments': 'Has No Attachments',
                    'filename-attachments': 'Filename Contains',
                    'extension-attachments': 'Extension Is',
                    'number-attachments': 'Has',
                    // Comments
                    'any-comments': 'Has Any Comments',
                    'none-comments': 'Has No Comments',
                    'contains-comments': 'Contain',
                    'not-contains-comments': 'Do Not Contain',
                    'made-by-comments': 'Made By Any Of',
                    'not-made-by-comments': 'Made By None Of',
                    'time-added-comments': 'Added Between',
                    // Text Input
                    'any-text-input': 'Has A Value',
                    'none-text-input': 'Has No Value',
                    'contains-text-input': 'Contains',
                    'not-contains-text-input': 'Does Not Contain',
                    // Numeric Input
                    'any-numeric': 'Has A Value',
                    'none-numeric': 'Has No Value',
                    'is-numeric': 'Is',
                    'out-of-range': 'Is Out-of-Range',
                    'not-out-of-range': 'Is Not Out-of-Range',
                    // Checkbox
                    'is-checkbox': 'Is',
                    // Text Choice
                    'any-text-choice': 'Has A Value',
                    'none-text-choice': 'Has No Value',
                    'includes-any-of-text-choice': 'Includes Any Of',
                    'missing-all-of-text-choice': 'Missing All Of',
                    'abnormal-choice': 'Is Abnormal',
                    'not-abnormal-choice': 'Is Not Abnormal',
                    // Signoff
                    'any-signoff': 'Has Been Signed-Off',
                    'none-signoff': 'Has Not Been Signed-Off',
                    'pending-includes-any-of-signoff': 'Pending Signoff For Any Of',
                    'includes-any-of-signoff': 'Signed-Off By Any Of',
                    'excludes-all-of-signoff': 'Signed-Off By None Of',
                    'specific-date-signoff': 'Signed-Off On Date',
                    'date-range-signoff': 'Signed-Off In Date Range',
                    'time-range-signoff': 'Signed-Off In Time Range',
                    'rejected-signoff': 'Has Been Rejected',
                    'not-rejected-signoff': 'Has Not Been Rejected',
                    // Inspection Segments
                    'has-segment-comment': 'Has Segment Comment(s)',
                    'has-no-segment-comment': 'Has No Segment Comments',
                    'has-segment-attachment': 'Has Segment Attachment(s)',
                    'has-no-segment-attachment': 'Has No Segment Attachments'
                }
            },
            plugins: {
                'sortable': {
                    icon: 'glyphicon glyphicon-menu-hamburger'
                }
            },
            templates: {
                filterSelect: '\
                    {{ var optgroup = null; }} \
                    <select class="form-control" name="{{= it.rule.id }}_filter"> \
                      {{? it.settings.display_empty_filter }} \
                        <option value="-1">{{= it.settings.select_placeholder }}</option> \
                      {{?}} \
                      {{~ it.filters: filter }} \
                        {{? optgroup !== filter.optgroup }} \
                          {{? optgroup !== null }}</optgroup>{{?}} \
                          {{? (optgroup = filter.optgroup) !== null }} \
                            <optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}"> \
                          {{?}} \
                        {{?}} \
                        <option value="{{= filter.id }}" {{? filter.icon}}data-icon="{{= filter.icon}}"{{?}}>{{= it.translate(filter.label) }}</option> \
                      {{~}} \
                      {{? optgroup !== null }}</optgroup>{{?}} \
                    </select>',

                operatorSelect: '\
                    {{ var optgroup = null; }} \
                    <select class="form-control" name="{{= it.rule.id }}_operator"> \
                      {{~ it.operators: operator }} \
                        {{? optgroup !== operator.optgroup }} \
                          {{? optgroup !== null }}</optgroup>{{?}} \
                          {{? (optgroup = operator.optgroup) !== null }} \
                            <optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}"> \
                          {{?}} \
                        {{?}} \
                        <option value="{{= operator.type }}" {{? operator.icon}}data-icon="{{= operator.icon}}"{{?}}>{{= it.translate("operators", operator.type) }}</option> \
                      {{~}} \
                      {{? optgroup !== null }}</optgroup>{{?}} \
                    </select>',

                rule: '\
                    <div id="{{= it.rule_id }}" class="rule-container"> \
                      {{? it.settings._viewOnlyMode }} \
                      <button type="button" class="btn btn-xs btn-primary condition"> \
                        <span class="condition"></span> \
                      </button> \
                      {{??}} \
                      <button type="button" class="btn btn-xs btn-primary condition condition-toggle"> \
                        <span class="condition"></span> \
                        <span class="caret"></span> \
                      </button> \
                      {{?}} \
                      <div class="rule-header"> \
                        <div class="btn-group pull-right rule-actions"> \
                          {{? !it.settings._viewOnlyMode }} \
                          <input type="checkbox" class="select-rule" /> \
                          {{?}} \
                          <button type="button" class="btn btn-xs btn-danger" data-delete="rule"> \
                            <i class="{{= it.icons.remove_rule }}"></i> \
                          </button> \
                        </div> \
                      </div> \
                      {{? it.settings.display_errors }} \
                        <div class="error-container"><i class="{{= it.icons.error }}"></i></div> \
                      {{?}} \
                      <div class="filter-operator-wrapper"> \
                        <div class="rule-filter-container"></div> \
                        <div class="rule-operator-container"></div> \
                        <div class="panel-group collapsed hide"> \
                          <div class="panel panel-default">\
                            <div class="panel-heading">\
                              <h4 class="panel-title">\
                                <a data-toggle="collapse" role="button">\
                                  Configuration \
                                </a>\
                              </h4>\
                            </div>\
                            <div class="panel-collapse collapse">\
                              <div class="panel-body">\
                                <label> \
                                  <input type="checkbox" value="Allow Configuring On Query" class="allow-config" checked> Allow configuring on Query? \
                                </label> \
                                <label> Field Name on Query: \
                                  <input type="text" class="form-control input-sm runtime-label">\
                                </label> \
                              </div>\
                            </div> \
                          </div> \
                        </div> \
                      </div> \
                      <div class="rule-value-container"></div> \
                    </div>',

                group: '\
                    <div id="{{= it.group_id }}" class="rules-group-container"> \
                      {{? it.settings._viewOnlyMode }} \
                      <button type="button" class="btn btn-xs btn-primary condition"> \
                        <span class="condition"></span> \
                      </button> \
                      {{??}} \
                      <button type="button" class="btn btn-xs btn-primary condition condition-toggle"> \
                        <span class="condition"></span> \
                        <span class="caret"></span> \
                      </button> \
                      {{?}} \
                      <div class="rules-group-header"> \
                        <div class="group-conditions"> \
                        </div> \
                        {{? it.settings.display_errors }} \
                          <div class="error-container"><i class="{{= it.icons.error }}"></i></div> \
                        {{?}} \
                      </div> \
                      <div class=rules-group-body> \
                        <div class=rules-list></div> \
                      </div> \
                      <div class="rules-group-footer clearfix"> \
                        <button type="button" class="btn btn-sm btn-link move-up hide"> \
                          <strong> \
                            <i class="glyphicon glyphicon-arrow-up"></i> Move Up a Group \
                          </strong> \
                        </button> \
                        <div class="btn-group pull-right"> \
                          <button type="button" class="btn btn-sm btn-success" data-add="rule"> \
                            <strong><i class="{{= it.icons.add_rule }}"></i> {{= it.translate("add_rule") }}</strong> \
                          </button> \
                          {{? it.settings.allow_groups===-1 || it.settings.allow_groups>=it.level }} \
                            <button type="button" class="btn btn-sm btn-success" data-add="group"> \
                              <strong><i class="{{= it.icons.add_group }}"></i> {{= it.translate("add_group") }}</strong> \
                            </button> \
                          {{?}} \
                          {{? it.level>1 }} \
                            <button type="button" class="btn btn-sm btn-danger" data-delete="group"> \
                              <i class="{{= it.icons.remove_group }}"></i> \
                            </button> \
                          {{?}} \
                        </div> \
                      </div> \
                    </div>'
            },
            filters: _defaultFiltersArray
        })

        _builder = $builder[0].queryBuilder;

        $builder.on('click', '.filter-operator-wrapper > div:last-child a', function(e) {
            var rule = $builder.queryBuilder('getModel', $(e.target).closest('.rule-container'));

            rule.$el.find('.collapse').collapse('toggle');
        })
        $builder.on('show.bs.collapse hidden.bs.collapse', '.filter-operator-wrapper .collapse', function() {
            $(this).closest('.panel-group').toggleClass('collapsed uncollapsed');
        })
        $builder.on('change', '.allow-config', function(e) {
            var rule = $builder.queryBuilder('getModel', $(e.target).closest('.rule-container')),
                $runtimeLabel = rule.$el.find('.runtime-label');

            $runtimeLabel.parent().toggleClass('hide', !this.checked);
            rule.data.allowConfigureOnQuery = this.checked;

            if (this.checked) {
                if (rule.data.hasOwnProperty('runtimeLabel'))
                    $runtimeLabel.val(rule.data.runtimeLabel);
                else {
                    if (!$runtimeLabel.val())
                        $runtimeLabel.val(rule.filter.label);

                    rule.data.runtimeLabel = $runtimeLabel.val();
                }
            }
            else
                delete rule.data.runtimeLabel;
        })
        $builder.on('change', '.filter-operator-wrapper .runtime-label', function(e) {
            var rule = $builder.queryBuilder('getModel', $(e.target).closest('.rule-container'));

            rule.data.runtimeLabel = this.value.trim();
        })
       
        $builder.on('click', 'button.condition-toggle', function(e) {
            var groupContainer = $(this).parent().parent().parent().closest('.rules-group-container'),
                group = $builder.queryBuilder('getModel', groupContainer);
            
            if ($reportTemplate.val() != 'Default (All Notes)') {
                group.condition = group.condition == 'AND' ? 'OR' : 'AND';
                return;
            }

            var templateGroupClicked = group.rules.some(function(rule) {
                return rule.operator && rule.operator.type == 'is-template';
            });

            if (group.condition == 'AND') {
                if (group.data.templateConstraint) {
                    var templateConstraintRoot = getRootANDGroup(group),
                        newTemplateConstraintRoot;

                    group.condition = 'OR';

                    if (!templateGroupClicked) {
                        var isTemplateRule = getIsTemplateRule(group);

                        if (!isTemplateRule)
                            return;
                            
                        newTemplateConstraintRoot = getRootANDGroup(isTemplateRule);
                    }

                    delete templateConstraintRoot.data.templateConstraint;

                    removeTemplateRules(templateConstraintRoot, newTemplateConstraintRoot);
                    refreshTemplateConstraints(templateConstraintRoot, newTemplateConstraintRoot);
                }
                else
                    group.condition = 'OR';
            }
            else {
                group.condition = 'AND';

                var childConstraintRoot;

                if (!templateGroupClicked) {
                    childConstraintRoot = !group.data.templateConstraint && group.rules.find(function(rule) {
                        return rule.condition && rule.data.templateConstraint;
                    });
                }

                if (templateGroupClicked || childConstraintRoot) {
                    var templateConstraintRoot = getRootANDGroup(group),
                        templateRuleCount = getTemplateRuleCount(templateConstraintRoot)

                    if (templateRuleCount > 1) {
                        alert('A template-constrained group or group hierarchy cannot contain more than one template rule.')
                        group.condition = 'OR';
                    }
                    else
                        addOrUpdateTemplateConstraints(templateConstraintRoot, childConstraintRoot);
                }
            }   
        });

        $builder.on('change', '.select-rule', function(e) {
            var group = $builder.queryBuilder('getModel', $(this).closest('.rules-group-container'));

            toggleGroupButtons(group);
        });

        $scope.reportTemplateFocus = function reportTemplateFocus() {
            var func =function()
            {
                $(this).data('previousTemplate', $(this).find(':selected'));
            };
            func.call($reportTemplate);
        };

        $scope.reportTemplateChange = function(override) {
            var func = function() {
                this.blur();

                var self = $(this);

                $q(function(resolve) {
                    if ($scope.report.id)
                        resolve(
                            $http.get('/api/reportViewEntries', {
                                params: {
                                    'report.id': $scope.report.id
                                }
                            })
                            .then(function(results) {
                                return results.data;
                            })
                        );
                    else
                        resolve({ _embedded: { reportViewEntries: [] } })
                })
                .then(function(response) {
                    $scope.reportViewEntriesToDelete = response._embedded.reportViewEntries.filter(function(element) {
                        return element.templateSegment !== null;
                    });

                    var templateSegmentsInReport = atLeastOneTemplateFieldInUse();

                    if ($scope.reportViewEntriesToDelete.length) {
                        var $modal = templateSegmentsInReport ?
                            $('#segments-in-output-and-report-warning') :
                            $('#segments-in-output-warning');

                        $modal.modal({ backdrop: 'static' });
                    }
                    else if (templateSegmentsInReport) {
                        var spanText = self.data('previousTemplate').val() == 'Default (All Notes)' ?
                            'one or more template fields' :
                            'fields from the ' + self.data('previousTemplate').text() + ' template';

                        $fieldsInUseWarning
                            .modal({ backdrop: 'static' })
                            .find('.modal-body span')
                            .html(spanText);
                    }
                    else {
                        if (self.data('previousTemplate').val() == 'Default (All Notes)')
                            removeTemplateConstraints();

                        refreshReportFilters();

                        if ($location.path() == '/report-editor')
                            $scope.updateOutput(self.val());
                    }
                });
            };

            func.call($reportTemplate);
        };

        $reportTemplate
            .focus($scope.reportTemplateFocus)
            .change($scope.reportTemplateChange);

        function confirmChanges()
        {
            if ($rootScope.user !== null && $scope.changesMade && !_userConfirmedLeave)
                return 'You have made changes without saving. Are you sure you want to leave?';
        }
        
        function confirmExit(event, callback)
        {
            if (!_reportLoaded)
                return;
            
            if ($rootScope.user && $scope.changesMade && !_userConfirmedLeave) {
                if (event)
                    event.preventDefault();

                $scope.unsavedChangesCallback = callback;

                $unsavedChangesModal.modal({ backdrop: 'static' });
            }
            else
                return true;
        }

        $scope.unsavedChangesDialogHandler = function(leave) {
            if (leave) {
                _userConfirmedLeave = true;
                
                $scope.unsavedChangesCallback();
            }
        }
        
        _logChangeStartSubscription = logService.logChangeStart$.subscribe(changeLog => {
            if (confirmExit(null, changeLog))
                changeLog();
        });

        $(window).on('beforeunload', confirmChanges);
    
        $scope.$on('logoutStart', confirmExit);
        $scope.$on('$locationChangeStart', function(event) {
            // Loading indicator will take over the UI without doing this...
            $scope.$emit('$routeChangeError');

            var url = $location.url();
            
            confirmExit(event, function() {
                $location.url(url);
            });
        });
        $scope.$on('$destroy', function() {
            $(window).off('beforeunload', confirmChanges);
            
            _logChangeStartSubscription.unsubscribe();
        });

        $('#builder-container').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
            $(this).removeClass('animate-bottom');
        });

        $builder.on('click', 'button.move-up', function(e) {
            var group = $builder.queryBuilder('getModel', $(this).closest('.rules-group-container')),
                rulesToMove = getSelectedRules(group);

            if (group.level == 1) {
                if (getSelectedRules(group, true).length) {
                    _topLevelMoveUpGroupClicked = true;

                    $builder.queryBuilder('addGroup', group);

                    rulesToMove.forEach(function(rule) {
                        rule.$el.find('.select-rule').prop('checked', false);
                    });

                    _topLevelMoveUpGroupClicked = false;
                }
                return;
            }

            var clearTemplateFilters = false;

            if ($reportTemplate.val() == 'Default (All Notes)') {
                var movingIsTemplateRule = function() {
                    return rulesToMove.some(function(rule) {
                        return rule.operator && rule.operator.type == 'is-template';
                    })
                };

                if (group.parent.condition == 'AND') {
                    if (group.condition == 'OR' && movingIsTemplateRule()) {
                        var rootANDGroup = getRootANDGroup(group.parent),
                            templateRuleCount = getTemplateRuleCount(rootANDGroup);

                        if (templateRuleCount > 1) {
                            alert('A template-constrained group or group hierarchy cannot contain more than one template rule.')
                            return;
                        }

                        addOrUpdateTemplateConstraints(rootANDGroup);
                    }
                }
                else if (group.condition == 'AND') {
                    if (movingIsTemplateRule()) {
                        rulesToMove = rulesToMove.filter(function(rule) {
                            return rule.filter && rule.filter.optgroup == 'Default Fields';
                        });

                        delete group.data.templateConstraint;

                        removeTemplateRules(group);
                        refreshTemplateConstraints(group);
                    }
                    else if (group.data.templateConstraint && !group.parent.data.templateConstraint) {
                        var movingTemplateFieldRule = rulesToMove.some(function(rule) {
                            return rule.filter && rule.filter.optgroup != 'Default Fields';
                        })

                        if (movingTemplateFieldRule) {
                            alert("You can only move a template field rule into a group having the same template constraint.");
                            return;
                        }

                        clearTemplateFilters = true;
                    }
                }
            }

            moveSelectedRules(group.parent, rulesToMove, clearTemplateFilters);

            $scope.updateChangeStatus(true);
        });

        $builder.on('click', '.rule-value-container input:checkbox[name]', function(e) {
            var $namedCheckboxes = $(this).closest('div').find('input:checkbox[name]'),
                $samename = $namedCheckboxes.filter('[name=' + this.name + ']'),
                $otherName = $namedCheckboxes.not($samename);

            if (this.checked) {
                $samename.parent().removeClass('disable-text');
                $otherName.prop('checked', false).parent().addClass('disable-text');
            }
            else if (!$samename.is(':checked'))
                $otherName.parent().removeClass('disable-text');
        })
        $builder.on('change', '.rule-container select:not(.selectpicker)', function() {
            // Preserves selected option in <select> tags while rule is being dragged to a new position
            $(this).find('[selected]').removeAttr('selected').end()
                .find(':selected').attr('selected', true);
        })

        $builder.on('change', '.is-template > select', function(e) {
            var group = $builder.queryBuilder('getModel', $(this).closest('.rules-group-container'));

            if (group.condition == 'AND') {
                var templateConstraintRoot = getRootANDGroup(group);
            
                removeTemplateRules(templateConstraintRoot);
                addOrUpdateTemplateConstraints(templateConstraintRoot);
            }
        })

        $builder.on('mousedown', '.drag-handle', function(e) {
            var node = this.parentElement.className == 'rule-container' ?
                $builder.queryBuilder('getModel', $(this.parentElement)) :
                $builder.queryBuilder('getModel', $(this).closest('.rules-group-container'));
            
            _beforeDragGroupAndIndex = {
                group: node.parent,
                index: node.getPos()
            };
        })

        loadReport();

        $('#toggle-view-only-mode').click(function() {
            _viewOnlyMode = !_viewOnlyMode;

            var button = this;
            $builder[0].queryBuilder.settings._viewOnlyMode = _viewOnlyMode;

            // _reportLoaded = false;
            // var rules = $builder.queryBuilder('getRules');
            // $builder.queryBuilder('setRules', rules);
            // _reportLoaded = true;

            loadReport().then(function() {
                var $reportTemplate = $('#report-template'),
                    $navDropdownMenu = $('#navbar .dropdown-menu'),
                    $dropdownInputs = $navDropdownMenu.find(':input');

                $reportTemplate.add($navDropdownMenu).toggleClass('values-disabled');

                if (_viewOnlyMode) {
                    button.textContent = 'Switch to Design Mode';
                    $reportTemplate.add($dropdownInputs).attr('tabindex', -1);
                }
                else {
                    button.textContent = 'Switch to View-Only Mode';
                    $reportTemplate.add($dropdownInputs).removeAttr('tabindex');
                }
            });
        });

        $(window).on('beforeunload', function() {
            if ($scope.changesMade)
                return 'You have made changes without saving. Are you sure you want to leave?';
        });

        $('#builder-container').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
            $(this).removeClass('animate-bottom');
        });
    };

    $scope.confirmFieldsInUse = function() {
        if ($reportTemplate.data('previousTemplate').val() == 'Default (All Notes)')
            removeTemplateConstraints();
        
        removeTemplateRules();
        refreshReportFilters();

        if ($location.path() == '/report-editor')
            $scope.updateOutput($reportTemplate.val());
    };

    $scope.cancelFieldsInUse = function() {
        $reportTemplate.val($reportTemplate.data('previousTemplate').val());
    };

    $scope.confirmSegmentsInOutput = function() {
        refreshReportFilters();

        $scope.deleteReportViewEntry($scope.reportViewEntriesToDelete).then(function() {
            if ($location.path() == '/report-editor')
                $scope.updateOutput($reportTemplate.val());
        });
    };

    $scope.cancelSegmentsInOutput = function() {
        $reportTemplate.val($reportTemplate.data('previousTemplate').val());
    };

    $scope.confirmSegmentsInOutputAndReport = function() {
        if ($reportTemplate.data('previousTemplate').val() == 'Default (All Notes)')
            removeTemplateConstraints();
        
        removeTemplateRules();
        refreshReportFilters();

        $scope.deleteReportViewEntry($scope.reportViewEntriesToDelete).then(function() {
            if ($location.path() == '/report-editor')
                $scope.updateOutput($reportTemplate.val());
        });
    };

    $scope.cancelSegmentsInOutputAndReport = function() {
        $reportTemplate.val($reportTemplate.data('previousTemplate').val());
    };

    function loadReport() {
        _reportLoaded = false;

        return $scope.getReportData.then(function(reportData) {
            if (_userConfirmedLeave)
                return;
            
            toggleViewOnlyMode();

            loadReportLogTemplates(reportData.templateId).then(function() {
                var queryJson = JSON.parse($scope.report.queryBuilderJson ||
                                           sessionStorage.getItem('startingRules')),
                    isDefaultTemplate = $reportTemplate.val() == 'Default (All Notes)';

                function onFiltersReady() {
                    if (!sessionStorage.getItem('startingRules'))
                        queryJson = mapQueryBuilderJson(queryJson);

                    setRules(queryJson);

                    $('#loader').addClass('hide');
                    $('#builder-container').removeAttr('style');

                    if (isDefaultTemplate && $location.path() == '/report-editor')
                        $scope.updateTemplatesInUse(Object.keys(_filterCache));
                        
                    _initializationPromise.resolve();

                    sessionStorage.removeItem('startingRules');

                    _reportLoaded = true;
                }

                if (isDefaultTemplate) {
                    refreshReportFilters();

                    var templatesSegments = getMultiTemplateReportSegments(queryJson);

                    if (templatesSegments && templatesSegments.length) {
                        // Get the template filters needed for any groups with a 'is-template' operator and an 'AND' condition
                        $.when.apply($, templatesSegments).done(function() {
                            if (_userConfirmedLeave)
                                return;
                            
                            for (var i = 0; i < arguments.length; i++)
                                $builder.queryBuilder('addFilter', arguments[i]);

                            onFiltersReady();
                        });
                    }
                    else
                        onFiltersReady();
                }
                else {
                    refreshReportFilters().done(function() {
                        if (_userConfirmedLeave)
                            return;

                        onFiltersReady();
                    });
                }
            });
        });
    }

    function getMultiTemplateReportSegments(queryJson) {
        if (!queryJson)
            return;

        var templatesNeeded = [];

        (function recurse(group) {
            group.rules.forEach(function(rule) {
                if (rule.rules)
                    recurse(rule);
                else if (rule.operator == 'is-template' &&
                    group.condition == 'AND' &&
                    !templatesNeeded.some(function(t) {
                        return t.templateId == rule.value.templateId &&
                               t.subTemplateId == rule.value.subTemplateId;
                    })) {
                    templatesNeeded.push(rule.value);
                }
            });
        }(queryJson));

        return templatesNeeded.map(function(template) {
            var selector = template.subTemplateId ?
                'data-logbook-subtemplate-id="' + template.subTemplateId :
                'value="' + template.templateId;

            var $selectedTemplate = $reportTemplate.find('option[' + selector + '"]');

            return getTemplateSegmentFilters($selectedTemplate);
        });
    }

    function loadReportLogTemplates(templateId, templates, allowDefault) {
        return $q(function(success)
        {
            allowDefault = (typeof allowDefault === "boolean") ? allowDefault : true;

            var logTemplates = templates || $scope.templates || [];

            _defaultBasicNoteTemplateId = (logTemplates.find(function(template) {
                return template.isDefaultTemplate;
            }) || {}).id;

            _reportTemplateDropdownHTML = logTemplates
                .map(function(logTemplate) {
                    if (logTemplate.templateType.id === 2 || !logTemplate.subTemplates.length)
                        return '<option value="' + logTemplate.id + '" ' + 'data-logbook-template-type="' + logTemplate.templateType.name + '">' + logTemplate.name + '</option>';
                    else
                        return '<optgroup label="' + logTemplate.name + '">' +
                            logTemplate.subTemplates.map(function(subTemp) {
                                return '<option value="' + logTemplate.id + '" ' + 'data-logbook-template-type="' + logTemplate.templateType.name +
                                    '" data-logbook-subtemplate-id="' + subTemp.id + '">' + subTemp.name + '</option>'
                            }).join('') +
                            '</optgroup>'
                })
                .sort(function(a, b) {
                    return $(a).text() > $(b).text() ? 1 : -1;
                })
                .join('');
            
            if (allowDefault)
                $reportTemplate.html('<option>Default (All Notes)</option>' + _reportTemplateDropdownHTML);
            else
                $reportTemplate.html(_reportTemplateDropdownHTML);

            var subTemplateId;

            if ($scope.subTemplate)
                subTemplateId = $scope.subTemplate.id;
            else {
                var startingTemplate = JSON.parse(sessionStorage.getItem('startingTemplate'));

                if (startingTemplate) {
                    templateId = startingTemplate.templateId;
                    subTemplateId = startingTemplate.subTemplateId;

                    $scope.updateOutput(templateId);

                    sessionStorage.removeItem('startingTemplate');
                }
            }

            if (subTemplateId)
                $reportTemplate.find('option[data-logbook-subtemplate-id="' + subTemplateId + '"]')
                    .prop('selected', true);
            else
                $reportTemplate.val(templateId || 'Default (All Notes)');

            success();
        });
    }

    function setRuntimeState(rule) {
        var $configPanel = rule.$el.find('.filter-operator-wrapper').children().last(),
            canConfigureOnRuntime =
                rule.filter &&
                rule.operator.type != 'is-template' && (
                rule.$el
                    .find('.rule-value-container > div > div.' + rule.operator.type + ' :first-child')
                    .prop('tagName') != 'EM'
                    ||
                    rule.filter.id == 'turnover'
                );

        $configPanel.toggleClass('hide', $scope.hideConfigPanel || !canConfigureOnRuntime)
            .find('input:checkbox')
            .prop('checked', _reportLoaded ? canConfigureOnRuntime : rule.data.allowConfigureOnQuery)
            .change();
    }

    function refreshReportFilters() {
        var filtersToRemove = [],
            $selectedTemplate = $reportTemplate.find(':selected'),
            subTemplateId = $selectedTemplate.data('logbook-subtemplate-id'),
            templateName = $selectedTemplate.text(),
            logBookTemplateType = $selectedTemplate.data('logbook-template-type'),
            previousLogBookTemplate = $reportTemplate.data('previousTemplate');

        if (templateName == 'Default (All Notes)') {
            if (previousLogBookTemplate) {
                var previousTemplate = getTemplateIdentifier(previousLogBookTemplate);

                Object.keys(_filterCache).forEach(function(template) {
                    if (template != previousTemplate)
                        $builder.queryBuilder('addFilter', _filterCache[template]);
                });
            }

            if (_reportLoaded && $location.path() == '/report-editor')
                $scope.updateTemplatesInUse([]);
        }
        else {
            $builder[0].queryBuilder.filters.forEach(function(filter) {
                if (filter.data.logBookTemplateType)
                    filtersToRemove.push(filter.id);
            });

            if ($location.path() == '/report-editor')
                $scope.updateTemplatesInUse([getTemplateIdentifier($selectedTemplate)]);
        }

        if ($selectedTemplate.val() == _defaultBasicNoteTemplateId)
            filtersToRemove.push('note');
        else if (previousLogBookTemplate && previousLogBookTemplate.text() === 'Basic Note')
            $builder.queryBuilder('addFilter', _defaultFieldFilters['Note'], 0);

        if (logBookTemplateType)
            filtersToRemove.push('template');
        else if (templateName === 'Default (All Notes)' && previousLogBookTemplate)
            $builder.queryBuilder('addFilter', _defaultFieldFilters['Template'], 0);

        if (filtersToRemove.length) {
            // Last argument causes any rules using the filters being removed to also be removed without an exception being thrown
            $builder.queryBuilder('removeFilter', filtersToRemove, true);
        }

        if (templateName != 'Default (All Notes)') {
            return getTemplateSegmentFilters($selectedTemplate).done(
                function(templateSegmentFilters) {
                    if (!_userConfirmedLeave) {
                        var templateSegments = _templateSegmentCache[$selectedTemplate.val()];

                        $scope.subTemplate = templateSegments.find(function(segment) {
                            return segment.id == subTemplateId;
                        });
                    
                        $builder.queryBuilder('addFilter', templateSegmentFilters);

                        cacheFilterOptions();

                        // Fires a $watchCollection function if refreshed from an alert trigger
                        if ($location.path() != '/report-editor')
                            $scope.templateSegments = $scope.filterFromSubTemplate(templateSegments, subTemplateId);
                    }
                }
            );
        }
    }

    function getTemplateSegmentFilters($selectedTemplate) {
        var templateSegmentFilters = _filterCache[getTemplateIdentifier($selectedTemplate)];

        // We already have the filters for the selected template option
        if (templateSegmentFilters)
            return $.when(templateSegmentFilters);

        var subTemplateId = $selectedTemplate.data('logbook-subtemplate-id'),
            templateSegments = _templateSegmentCache[$selectedTemplate.val()];

        // We have the template segments for the selected template option but haven't yet created filters for it
        if (templateSegments) {
            templateSegments = $scope.filterFromSubTemplate(templateSegments, subTemplateId);
            templateSegmentFilters = createTemplateSegmentFilters($selectedTemplate, templateSegments);

            return $.when(templateSegmentFilters);
        }

        // We need to get the template segments from the server, cache them, and create the query filters for the selected template option
        return $.getJSON('api/templateSegments',
            {
                template: ($selectedTemplate || $reportTemplate).val(),
                sort: 'sortOrder',
                obsolete: false,
                size: 10000
            })
            .then(function(data) {
                _templateSegmentCache[$selectedTemplate.val()] = data._embedded.templateSegments;

                templateSegments = $scope.filterFromSubTemplate(data._embedded.templateSegments, subTemplateId);

                return createTemplateSegmentFilters($selectedTemplate, templateSegments);
            });
    }

    function createTemplateSegmentFilters($selectedTemplate, templateSegments) {
        var templateSegmentFilters = [],
            optgroup = $selectedTemplate.text();

        templateSegments
            .sort(function(a, b) {
                return a.sortOrder > b.sortOrder ? 1 : -1;
            })
            .forEach(function(segment) {
                if (segment.level)
                    optgroup = $selectedTemplate.text() + ' > ' + segment.longName.replace(/;/g, ' >');

                if (!_templateSegmentFilters.hasOwnProperty(segment.type.name))
                    return;

                segment.logBookTemplateType = $selectedTemplate.data('logbook-template-type');
                segment.optgroup = optgroup;

                Array.prototype.push.apply(templateSegmentFilters, getFiltersFromTemplateSegment(segment));
            });

        _filterCache[getTemplateIdentifier($selectedTemplate)] = templateSegmentFilters;

        return templateSegmentFilters;
    }

    function getFiltersFromTemplateSegment(segment) {
        var segmentType = segment.type.name,
            filters = _templateSegmentFilters[segmentType];

        if (segmentType == 'Date/Time') {
            var subType = segment.includeDate && segment.includeTime ? 'Date And Time' :
                segment.includeDate ? 'Date Only' :
                    segment.includeTime ? 'Time Only' :
                        'Date And Time';

            filters = filters[subType];
        }

        filters = [filters];

        var templateSegmentFilters = [];

        filters.forEach(function(filter, index) {
            var segmentFilter = {
                id: segment.id,
                label: segment.name,
                data: {
                    htmlTemplateId: filter.htmlTemplateId,
                    logBookTemplateType: segment.logBookTemplateType,
                    logBookTemplateSegmentType: segmentType,
                    choiceListId: segment.choiceList ? segment.choiceList.id : null,
                    sortOrder: segment.sortOrder,
                    units: segment.units ? segment.units : null,
                    parentTag: segment.tagValue ? { id: segment.tagValue.id, depth: segment.depth === 0 ? null : segment.depth } : null
                },
                input: getRuleValueContainer,
                input_event: filter.input_event,
                optgroup: segment.optgroup,
                operators: filter.operators,
                default_operator: filter.default_operator,
                valueGetter: filter.valueGetter,
                valueSetter: filter.valueSetter,
                validation: filter.validation
            };

            if (segment.logBookTemplateType === 'Inspection' && segmentType !== 'Signoff')
                segmentFilter.operators.push('has-segment-comment', 'has-no-segment-comment', 'has-segment-attachment', 'has-no-segment-attachment');

            templateSegmentFilters.push(segmentFilter);
        });

        return templateSegmentFilters;
    }

    function atLeastOneTemplateFieldInUse() {
        var templateFieldsInUse = false;

        (function recurse(group) {
            group.each(
                function(rule) {
                    if (rule.filter && rule.filter.data.logBookTemplateType) {
                        templateFieldsInUse = true;
                        return false; // stops iteration
                    }
                },
                function(group) {
                    recurse(group);

                    if (templateFieldsInUse)
                        return false; // stops iteration
                }
            );
        }($builder.queryBuilder('getModel')));

        return templateFieldsInUse;
    }

    function getTemplatesInUse() {
        var rootGroup = $builder.queryBuilder('getModel');

        if (rootGroup.data.templateConstraint)
            return [rootGroup.data.templateConstraint];

        var templatesInUse = [];

        (function recurse(group) {
            group.each(null, function(group) {
                var template = group.data.templateConstraint;

                if (template && !templatesInUse.includes(template))
                    templatesInUse.push(template);
                else
                    recurse(group);
            });
        }(rootGroup));

        return templatesInUse;
    }

    function removeTemplateRules(group, skipGroup) {
        if (!group)
            group = $builder.queryBuilder('getModel');

        group.each(true,
            function(rule) {
                if (rule.filter && rule.filter.data.logBookTemplateType)
                    $builder.queryBuilder('deleteRule', rule);
            },
            function(group) {
                if (group != skipGroup)
                    removeTemplateRules(group, skipGroup);
            }
        );
    }

    function removeTemplateConstraints() {
        var rootGroup = $builder.queryBuilder('getModel');

        delete rootGroup.data.templateConstraint;

        refreshTemplateConstraints(rootGroup);
    }

    function getTemplateIdentifier($selectedTemplate) {
        var subTemplateId = $selectedTemplate.data('logbook-subtemplate-id');

        if (subTemplateId)
            return subTemplateId + 'S';

        return $selectedTemplate.val() + 'T';
    }

    function getIsTemplateRule(group) {
        var isTemplateRule;

        (function recurse(group) {
            group.each(true,
                function(rule) {
                    if (rule.operator && rule.operator.type == 'is-template') {
                        isTemplateRule = rule;
                        return false; // stops iteration
                    }
                },
                function(group) {
                    recurse(group);
                }
            );
        }(group));

        return isTemplateRule;
    }

    function getTemplateRuleCount(group) {
        var templateRuleCount = 0;

        (function recurse(group) {
            group.each(true,
                function(rule) {
                    var htmlTemplateId = rule.data.htmlTemplateId;
            
                    if (!htmlTemplateId)
                        htmlTemplateId = rule.filter ? rule.filter.data.htmlTemplateId : null;
                    
                    if (htmlTemplateId == 'template') {
                        templateRuleCount++;

                        if (templateRuleCount == 2)
                            return false; // stops iteration
                    }
                },
                function(group) {
                    recurse(group);
                }
            );
        }(group));

        return templateRuleCount;
    }

    function getSelectedRules(group, invert) {
        return group.rules.filter(function(rule) {
            if (rule.condition)
                return;
            
            var $checkbox = rule.$el.find('.select-rule');

            return $checkbox.prop('checked') == !invert;
        });
    }

    function moveSelectedRules(moveIntoGroup, rules, refreshFilters) {
        var moveFromGroup = rules[0].parent,
            index = moveIntoGroup.rules.length ? moveFromGroup.getPos() : 0;

        rules.forEach(function(rule) {
            rule.move(moveIntoGroup, index);

            if (refreshFilters)
                refreshFilterHTML(rule);

            rule.$el.find('.select-rule').prop('checked', false);
            rule.$el.children().first().find('.condition').text(moveIntoGroup.condition);

            index++;
        });

        toggleGroupButtons(moveFromGroup);
    }

    function toggleGroupButtons(group, skipRule) {
        var atLeastOneSelected = group.rules.some(function(rule) {
            return !rule.condition && rule != skipRule && rule.$el.find('.select-rule').prop('checked');
        }),
        showMoveUpButton = atLeastOneSelected && (group.level > 1 || group.rules.some(function(rule) {
            return !rule.condition && rule != skipRule && !rule.$el.find('.select-rule').prop('checked');
        }));

        group.$el.children('.rules-group-footer')
            .children('.move-up').toggleClass('hide', !showMoveUpButton).end()
            .find('button[data-add="group"] > strong').contents().last()
                .replaceWith(atLeastOneSelected ? ' Group Selected' : ' ' + _builder.lang.add_group);
    }

    function cacheFilterOptions() {
        var templateIdentifier = getTemplateIdentifier($reportTemplate.find('option:selected'));

        if (_filterOptionsCache[templateIdentifier])
            return;

        (function recurse(group) {
            group.each(
                function(rule) {
                    _filterOptionsCache[templateIdentifier] = rule.$el.find('.rule-filter-container .selectpicker').html();
                    return false;
                },
                function(group) {
                    recurse(group);

                    if (_filterOptionsCache[templateIdentifier])
                        return false;
                }
            );
        }($builder.queryBuilder('getModel')));
    }

    function getRootANDGroup(node) {
        if (!node.condition)
            node = node.parent;
        
        if (node.condition == 'OR')
            return null;

        while (node.parent && node.parent.condition == 'AND')
            node = node.parent;
            
        return node;
    }

    function getTemplateConstraintRootGroup(node) {
        if (!node.condition)
            node = node.parent;
        
        while (node.parent && node.parent.data.templateConstraint)
            node = node.parent;
            
        return node;
    }

    function addOrUpdateTemplateConstraints(node, skipGroup) {
        var $selectedTemplate = node.$el.find('.is-template option:selected'),
            templateIdentifier = getTemplateIdentifier($selectedTemplate);

        if (!node.condition)
            node = node.parent;

        node.data.templateConstraint = templateIdentifier;

        refreshTemplateConstraints(node, skipGroup);

        if (!_filterCache[templateIdentifier]) {
            getTemplateSegmentFilters($selectedTemplate).done(
                function(templateSegmentFilters) {
                    $builder.queryBuilder('addFilter', templateSegmentFilters);
                }
            );
        }
    }

    function refreshTemplateConstraints(group, skipGroup) {
        (function recurse(group, skipGroup) {
            group.each(refreshFilterHTML, function(group) {
                if (group != skipGroup) {
                    if (group.parent.data.templateConstraint)
                        group.data.templateConstraint = group.parent.data.templateConstraint;
                    else
                        delete group.data.templateConstraint;

                    recurse(group, skipGroup);
                }
            });
        }(group, skipGroup));

        if ($location.path() == '/report-editor')
            $scope.updateTemplatesInUse(getTemplatesInUse());
    }

    function refreshFilterHTML(rule) {
        var $selectPicker;

        if (rule.parent.data.templateConstraint) {
            var filterHTML = _filterOptionsCache[rule.parent.data.templateConstraint];

            if (!filterHTML) {
                // Filters will be updated in .on('getRuleFilters.queryBuilder.filter') event
                return;
            }

            if (rule.operator && rule.operator.type == 'is-template')
                return;

            $selectPicker = rule.$el.find('.rule-filter-container select');

            var selectedValue = $selectPicker.val();

            $selectPicker.html(filterHTML).val(selectedValue);
        }
        else {
            $selectPicker = rule.$el.find('.rule-filter-container select');

            // Remove old template constraint filters and add template filter back
            $selectPicker.children(':gt(1)').remove();

            if (!$selectPicker.find('option[value="template"]').length)
                $selectPicker.children('optgroup').prepend('<option value="template">Template</option>');
        }

        $selectPicker.selectpicker('refresh');
    }

    function getRuleValueContainer(rule, name) {
        var templateContent = $('#' + rule.filter.data.htmlTemplateId).clone().prop('content'),
            inspectionTemplateCommonFields =
                rule.filter.data.logBookTemplateType === 'Inspection' ?
                    $inspectionTemplateCommonFields.clone().prop('content') : '';

        var valueContainer = $(templateContent.children)
            .each(function() {
                $(this).toggleClass('hide', !$(this).hasClass(rule.operator.type))
                    .find('input:radio')
                    .attr('name', rule.id);
            })
            .wrapAll('<div class=' + rule.filter.data.htmlTemplateId + '></div>')
            .parent()
            .append(inspectionTemplateCommonFields);

        if (rule.filter.data.units)
            valueContainer.find('#numeric-units').text(rule.filter.data.units);

        return valueContainer.prop('outerHTML');
    }

    function initializePlugins(e, rule) {
        // Selecting a time input auto selects the radio button for that row
        rule.$el.find('label .form-control').click(function(e) {
            $(this).siblings(':radio').prop('checked', true)
        });

        rule.$el.find('.date-time-picker > div').each(function() {
            $(this).datetimepicker({
                format: this.dataset.format,
                showTodayButton: true,
                showClear: true,
                showClose: true,
                allowInputToggle: true
            });

            var timeClass = this.parentElement.classList.item(1),
                todayButtonTooltip = timeClass === 'has-time' ? 'Current Date/Time' :
                    timeClass === 'time-only' ? 'Current Time' :
                        'Current Date';

            $(this).data('DateTimePicker').tooltips({ today: todayButtonTooltip });
        });

        var $tagPickers = rule.$el.find('.tag-picker > :input');
        if ($tagPickers.length)
            initializeTagChooserRule(rule, $tagPickers);

        var $userPickers = rule.$el.find('.user-picker > :input');
        if ($userPickers.length)
            initializeUserChooserRule(rule, $userPickers);

        if (rule.filter.data.logBookTemplateSegmentType === 'Text Choice')
            initializeTextChoiceRule(rule);

        if (rule.$el.find('.template-picker > :input').length)
            initializeTemplateRule(rule);
    }

    function initializeTagChooserRule(rule, $tagPickers) {
        rule.filter.data.getTagValues =
            $.getJSON('api/tagValues', {
                log: $scope.selectedLog.id,
                size: 20,
                page: 0,
                sort: 'viewString'
            })
                .then(function(data) {
                    var $selectize = $tagPickers.selectize({
                        preload: true,
                        valueField: 'id',
                        labelField: 'viewString',
                        searchField: ['viewString', 'override'],
                        create: false,
                        loadThrottle: 600,
                        loadingClass: 'loading',
                        plugins: ['remove_button', 'infinite_scroll'],
                        load: function(query, callback) {
                            var self = this;
                            if (!query.length)
                                return;
                            query = JSON.parse(query);

                            var instanceParams = {
                                log: $scope.selectedLog.id,
                                page: query.page,
                                matches: query.search,
                                size: 20,
                                sort: 'viewString'
                            };

                            var parentTag = rule.filter.data.parentTag;

                            var urlParams = Object.keys(instanceParams).map(function(field) {
                                return encodeURI(field + '=' + instanceParams[field]).replace('/%20/', '+');
                            }).join('&');

                            if (parentTag) {
                                urlParams += encodeURI('&parentDepthSpec=' + parentTag.id);
                                if (parentTag.depth) urlParams += encodeURI('&parentDepthSpec=' + parentTag.depth);
                            }

                            var url = 'api/tagValues?' + urlParams;
                            if (query.page > self.maxPages) return;
                            $.ajax({
                                url: url,
                                type: 'get',
                                dataType: 'json',
                                success: function(data) {
                                    self.maxPages = data.page.totalPages;

                                    // Adds override search term to match the query for search phrasing as logbook does the search
                                    // matches for phrase searching
                                    if (query.search.match('(".+")+')) {
                                        data._embedded.tagValues.forEach(function(tag) {
                                            tag.override = query.search;
                                        });
                                    }

                                    callback(data._embedded.tagValues);

                                    // Highlights quoted expressions
                                    var expression = /"([^"]*)"/g;
                                    var dropdown = self.$dropdown_content;
                                    var match = expression.exec(query.search);
                                    while (match != null) {
                                        self.highlight(dropdown, match[1]);
                                        match = expression.exec(query.search);
                                    }
                                },
                                error: function() {
                                    callback()
                                }
                            });
                        },
                        onInitialize: function() {
                            var reportField;

                            // Adds tags that belong to the report
                            if (_reportLoaded) {
                                reportField = $scope.getReportData.$$state.value.reportFields
                                    .find(function(element) {
                                        return element.id === rule.data.reportFieldId;
                                    });
                                if (reportField && reportField.tagValues.length > 0) {
                                    this.addOption(reportField.tagValues);
                                    this.addItems(reportField.tagValues.map(function(tag) { return tag.id; }))
                                }
                            }
                            else {
                                loadReportFields(this, $scope.report.id, $scope.selectedLog.id, "tagValues");
                            }
                        }
                    });
                });
    }

    function initializeUserChooserRule(rule, $userPickers) {
        if (_logUsers) {
            $userPickers.selectize({
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                sortField: 'name',
                create: false,
                plugins: ['remove_button'],
                onInitialize: function() {
                    this.addOption(_logUsers);
                }
            });
        }
        else {
            rule.filter.data.getLogBookUsers =
                $.getJSON('api/logBookUsers', {
                    historicalLogUser: $scope.selectedLog.id
                })
                    .then(function(data) {
                        $userPickers.selectize({
                            valueField: 'id',
                            labelField: 'name',
                            searchField: 'name',
                            sortField: 'name',
                            create: false,
                            plugins: ['remove_button'],
                            onInitialize: function() {
                                _logUsers = _logUsers || data._embedded.logBookUsers.map(function(usr) {
                                    return {
                                        id: usr.id,
                                        name: usr.firstName + ' ' + usr.lastName
                                    };
                                });

                                _logUsers.push({ id: 'current', name: 'Current User' });

                                this.addOption(_logUsers);
                            }
                        });
                    });
        }
    }

    function initializeTextChoiceRule(rule) {
        rule.filter.data.getChoiceListItems =
            $.getJSON('api/choiceListItems', {
                size: 20,
                list: rule.filter.data.choiceListId,
                sort: 'asc'
            })
                .then(function(data) {

                var $selectize = rule.$el.find('.text-picker > :input').selectize({
                    preload: true,
                        valueField: 'value',
                        labelField: 'value',
                    searchField: ['value', 'override'],
                        create: false,
                    loadThrottle: 600,
                    loadingClass: 'loading',
                    plugins: ['remove_button', 'infinite_scroll'],
                    load: function(query, callback)
                    {
                        var self = this;
                        if (!query.length)
                            return;
                        query = JSON.parse(query);

                        var instanceParams = {
                            list: rule.filter.data.choiceListId,
                            page: query.page,
                            matches: query.search,
                            size: 20,
                            sort: 'asc'
                        };

                        var urlParams = Object.keys(instanceParams).map(function(field)
                        {
                            return encodeURI(field + '=' + instanceParams[field]).replace('/%20/', '+');
                        }).join('&');

                        var url = 'api/choiceListItems?' + urlParams;
                        if (query.page > self.maxPages) return;
                        $.ajax({
                            url: url,
                            type: 'get',
                            dataType: 'json',
                            success: function(data)
                            {
                                self.maxPages = data.page.totalPages;

                                // Adds override search term to match the query for search phrasing as logbook does the search
                                // matches for phrase searching
                                if (query.search.match('(".+")+'))
                                {
                                    data._embedded.choiceListItems.forEach(function (choiceListItem) {
                                        choiceListItem.override = query.search;
                                    });
                                }

                                callback(data._embedded.choiceListItems);

                                // Highlights quoted expressions
                                var expression = /"([^"]*)"/g;
                                var dropdown = self.$dropdown_content;
                                var match = expression.exec(query.search);
                                while (match != null)
                                {
                                    self.highlight(dropdown, match[1]);
                                    match = expression.exec(query.search);
                                }
                            },
                            error: function()
                            {
                                callback()
                            }
                        });
                    },
                        onInitialize: function() {
                        var reportField;

                        // Adds choiceListItems that belong to the report
                        if (_reportLoaded)
                        {
                            reportField = $scope.getReportData.$$state.value.reportFields
                                .find(function(element)
                                {
                                    return element.id === rule.data.reportFieldId;
                                });
                            if (reportField && reportField.contains.length > 0)
                            {
                                this.addOption(reportField.contains.map(function(choiceListItem) { return { value: choiceListItem}}));
                                this.addItems(reportField.contains)
                            }
                        }
                        else
                        {
                            loadReportFields(this, $scope.report.id, $scope.selectedLog.id, "choiceListItems");
                        }
                        }
                    });
                });
    }

    function initializeTemplateRule(rule) {
        rule.filter.data.getTemplates = $q(function(resolve) { resolve() })
            .then(function() {
                var optGroups = $scope.templates
                    .filter(function(template) { return template.subTemplates.length && template.templateType.id === 1 })
                    .map(function(template) { return { groupName: template.name, id: template.id } });

                rule.$el.find('.template-picker > :input').selectize({
                    valueField: 'id',
                    labelField: 'name',
                    searchField: ['name', 'groupName'],
                    sortField: [
                        { field: 'groupName', direction: 'asc' },
                        { field: 'name', direction: 'asc' }
                    ],
                    optgroups: optGroups,
                    optgroupField: 'groupName',
                    optgroupLabelField: 'groupName',
                    optgroupValueField: 'groupName',
                    create: false,
                    plugins: ['remove_button'],
                    onInitialize: function() {
                        var subGroups = [];
                        var options = [];
                        options = options.concat($scope.templates.filter(function(template) {
                            if (template.isDefaultTemplate) {
                                template.id = 'Basic Note';
                                return true;
                            }

                            if (template.subTemplates.length && template.templateType.id === 1)
                                subGroups = subGroups.concat(template.subTemplates.map(function(subTemplate) {
                                    return { name: subTemplate.name, groupName: template.name, id: subTemplate.id + 'S' }
                                }));
                            else
                                return true;
                        }).map(function(temp) {
                            var toReturn = Object.assign({}, temp);
                            toReturn.id = toReturn.id + 'T';
                            return toReturn;
                        }));

                        this.addOption(options.concat(subGroups));
                    }
                });
            });
    }

    function checkInspectionSegmentSettings(rule) {
        switch (rule.operator.type) {
            case 'has-segment-comment':
            case 'has-no-segment-comment':
                return rule.operator.type === 'has-segment-comment';
            case 'has-segment-attachment':
            case 'has-no-segment-attachment':
                return rule.operator.type === 'has-segment-attachment';
        }
    }

    function validateDateTime(value) {
        switch (value[0]) {
            case 'Number of Days Ago':
                value[1] = parseInt(value[1], 10);
                break;

            case 'Between Days Ago':
                value[1] = parseInt(value[1], 10);
                value[2] = parseInt(value[2], 10);

                if (value[1] < value[2]) {
                    var x = value[1];
                    value[1] = value[2];
                    value[2] = x;
                }
                break;

            case 'Between Dates':
            case 'Between Dates/Times':
                if (Date.parse(value[1]) > Date.parse(value[2])) {
                    var x = value[1];
                    value[1] = value[2];
                    value[2] = x;
                }
                break;
        }

        return true;
    }

    var sortOrderCount = -1;

    /**
     * Maps Template and sub template save data for compatibility with Logbook
     * @param {Array} children - Children to map
     */
    function mapTemplateData(children) {
        children.forEach(function(child) {
            if (child.templates) {
                var templates = [], subTemps = [];

                for (var i = 0; i < child.templates.length; i++) {
                    var switchEle = child.templates[i][child.templates[i].length - 1],
                        url = child.templates[i].substring(0, child.templates[i].length - 1);

                    switch (switchEle) {
                        case 'S':
                            subTemps.push(url.replace('templates', 'templateSegments'));
                            break;

                        case 'T':
                            templates.push(url);
                            break;
                    }
                }

                child.templates = templates;
                child.subTemplates = subTemps;
            }
            else if (child.children)
                mapTemplateData(child.children)
        });
    }

    /**
     * Maps older version of QueryBuilderJson for compatibility with sub templates and removes
     * template fields that are no longer present in the queryJson.
     *
     * @param {Array|{rules:Array}} toParse - QueryBuilderJson Rules or QueryBuilderJson Object
     */
    function mapQueryBuilderJson(toParse) {
        var filterIds = (_builder.filters) ? _builder.filters.map(function(filter) { return filter.id }) : [];
        var rules = (Array.isArray(toParse)) ? toParse : ((toParse) ? toParse.rules : null);

        if (!rules || !Array.isArray(rules))
            return;

        for (var i = rules.length - 1; i >= 0; i--) {
            var rule = rules[i];

            // Removes rules if they do not exist in the filterId list
            if (!filterIds.includes(rule.id) && !rule.rules) {
                rules.splice(i, 1);
                continue;
            }

            if (rule.id && rule.id === 'template' && Array.isArray(rule.value)) {
                for (var x = 0; x < rule.value.length; x++) {
                    // Assigns Template 'T' to unassigned template IDs
                    var value = rule.value[x];
                    if (!isNaN(value[value.length - 1]))
                        rule.value[x] = value + 'T';
                }
            }
            else if (rule.rules)
                mapQueryBuilderJson(rule.rules)
        }
        return toParse;
    }

    $scope.saveCriteria = function(resolve, reject) {
        var rules = $('#builder').queryBuilder('getRules');
        if (!rules) {
            reject('No Rules');
            return;
        }

        sortOrderCount = -1;
        var subIds = $scope.getSubTemplateIds();
        var templateIds = $scope.getTemplateIds();

        var output = processRules(rules),
            data = { children: output.children },
            queryJson = JSON.stringify(rules),
            previousValues = {},
            queryChanged;

        mapTemplateData(data.children);

        var saveTemplate = function() {
            $.getJSON('/api/reports', { id: $scope.report.id }).done(function(response) {
                previousValues.queryBuilderJson = response._embedded.reports[0].queryBuilderJson;
                previousValues.templateId = response._embedded.reports[0].template
                    ? response._embedded.reports[0].template.id.toString() : null;
                queryChanged = queryJson !== previousValues.queryBuilderJson || $scope.subTemplate !== response._embedded.reports[0].subTemplate;

                if (($reportTemplate.val() === 'Default (All Notes)' && previousValues.templateId) ||
                    ($reportTemplate.val() !== 'Default (All Notes)' && !previousValues.templateId) ||
                    ($reportTemplate.val() !== 'Default (All Notes)' && $reportTemplate.val() !== previousValues.templateId)) {
                    $.ajax({
                        url: '/api/reports/' + $scope.report.id,
                        type: 'PATCH',
                        data: JSON.stringify({
                            'template': ($reportTemplate.val() === 'Default (All Notes)'
                                ? null : '/api/templates/' + $reportTemplate.val())
                        }),
                        processData: false,
                        contentType: 'application/json'
                    }).done(function() {
                        if (queryChanged) saveRoot();
                        else {
                            $scope.updateChangeStatus(false);
                            resolve();
                        }
                    }).fail(function(jqXHR) {
                        reject();
                    });
                } else {
                    if (queryChanged) saveRoot();
                    else {
                        $scope.updateChangeStatus(false);
                        resolve();
                    }
                }
            }).fail(function(jqXHR) {
                reject();
            });
        },
            saveRoot = function() {
                $.getJSON('/api/reportFields', { report: $scope.report.id }).done(function(response) {
                    var root = response._embedded.reportFields.find(function(element) {
                        return element.parentId === null;
                    });
                    previousValues.root = root;
                    if (output.operator.split('/').pop() !== root.operator.id.toString()) {
                        $.ajax({
                            url: '/api/reportFields/' + root.id,
                            type: 'PATCH',
                            data: JSON.stringify({ 'operator': output.operator }),
                            processData: false,
                            contentType: 'application/json'
                        }).done(function() {
                            saveFields(root);
                        }).fail(function(jqXHR) {
                            reject();
                        });
                    } else {
                        saveFields(root);
                    }
                }).fail(function(jqXHR) {
                    reject();
                });
            },
            saveFields = function(root) {
                $.ajax({
                    url: '/api/reportFields/' + root.id,
                    type: 'PATCH',
                    data: JSON.stringify(data),
                    processData: false,
                    contentType: 'application/json'
                }).done(function() {
                    saveJson();
                }).fail(function(jqXHR) {
                    reject();
                });
            },
            saveJson = function() {
                $.getJSON('/api/reportFields', { report: $scope.report.id }).done(function(response) {
                    var reportFields = response._embedded.reportFields,
                        queryBuilderJson = JSON.parse(queryJson);

                    processFields(reportFields, queryBuilderJson);
                    queryBuilderJson = JSON.stringify(queryBuilderJson);

                    $.ajax({
                        url: '/api/reports/' + $scope.report.id,
                        type: 'PATCH',
                        data: JSON.stringify({
                            'subTemplate': (($scope.subTemplate) ? ('/api/templateSegments/' + $scope.subTemplate.id) : null),
                            'queryBuilderJson': queryBuilderJson
                        }),
                        processData: false,
                        contentType: 'application/json'
                    }).done(function() {
                        $scope.updateChangeStatus(false);
                        resolve();
                    }).fail(function(jqXHR) {
                        reject();
                    });
                }).fail(function(jqXHR) {
                    reject();
                });
            };

        saveTemplate();
    }

    function rollBackSave(failurePoint, previousValues, jqXHR) {
        var rollBackTemplate = function() {
            return $.ajax({
                url: '/api/reports/' + $scope.report.id,
                type: 'PATCH',
                data: JSON.stringify({ 'template': (previousValues.templateId ? '/api/templates/' + previousValues.templateId : null) }),
                processData: false,
                contentType: 'application/json'
            });
        },
            rollBackRoot = function() {
                return $.ajax({
                    url: '/api/reportFields/' + previousValues.root.id,
                    type: 'PATCH',
                    data: JSON.stringify({ 'operator': '/api/logicalOperators/' + previousValues.root.operator.id }),
                    processData: false,
                    contentType: 'application/json'
                }).done(function() {
                    return rollBackTemplate();
                });
            },
            rollBackFields = function() {
                var childrenFields = { children: processRules(JSON.parse(previousValues.queryBuilderJson)).children };
                $.ajax({
                    url: '/api/reportFields/' + root.id,
                    type: 'PATCH',
                    data: JSON.stringify(childrenFields),
                    processData: false,
                    contentType: 'application/json'
                }).done(function() {
                    return rollBackRoot();
                });
            };

        console.error(jqXHR);
        switch (failurePoint) {
            case 'saveTemplate':
                break;
            case 'saveRoot':
                rollBackTemplate();
                break;
            case 'saveFields':
                rollBackRoot();
                break;
            case 'saveJson':
                rollBackFields();
                break;
        }
    }

    function processRules(rulesObject) {
        sortOrderCount++;
        var condition = rulesObject.condition,
            rules = rulesObject.rules;

        var operatorMap = {
            "AND": "/api/logicalOperators/1",
            "OR": "/api/logicalOperators/2"
        };

        var conditionJSON = {
            "operator": operatorMap[condition],
            "report": '/api/reports/' + $scope.report.id,
            "sortOrder": sortOrderCount,
            "children": []
        };

        for (var i = 0; i < rules.length; i++) {
            if (rules[i].condition)
                conditionJSON['children'].push(processRules(rules[i], conditionJSON.id));
            else {
                sortOrderCount++;

                conditionJSON['children'].push($scope.reportMapping.createPayload(
                    rules[i], $scope.report.id, sortOrderCount, false, _defaultBasicNoteTemplateId)
                );
            }
        }

        return conditionJSON;
    }

    function processFields(fieldsArray, queryJson, parentId) {
        if (!parentId) {
            parentId = fieldsArray.find(function(element) {
                return !element.parentId;
            }).id;
        }

        var rulesArray = fieldsArray.filter(function(element) {
            return element.parentId === parentId;
        });
        rulesArray.sort(function(a, b) { return a.sortOrder - b.sortOrder; });

        for (var i = 0; i < queryJson.rules.length; i++) {
            var rule = queryJson.rules[i];

            if (rule.condition)
                processFields(fieldsArray, rule, rulesArray[i].id);
            else {
                rule.data.reportFieldId = rulesArray[i].id;
            }
        }
    }

    function toggleViewOnlyMode() {
        _viewOnlyMode = $location.path() == '/report-editor' && !$scope.userHasEdit;

        _builder.settings._viewOnlyMode = _viewOnlyMode;

        $('.rule-header, .rules-group-footer, .drag-handle').toggleClass('hide', _viewOnlyMode);
        $('#report-template').prop('disabled', _viewOnlyMode);
    }

    function setRules(queryJson) {
        if (!queryJson)
            return;

        (function recurse(group) {
            group.readonly = _viewOnlyMode;
            group.flags = { no_sortable: _viewOnlyMode };
    
            group.rules.forEach(function(rule) {
                if (rule.condition)
                    recurse(rule);
                else
                    rule.readonly = _viewOnlyMode;
            });
        }(queryJson));

        _builder.setRules(queryJson);

        $scope.updateChangeStatus(false);
    }

    $scope.$watch('userHasEdit', function() {
        if ($location.path() == '/report-editor' && _reportLoaded) {
            toggleViewOnlyMode();

            setRules($builder.queryBuilder('getRules'));
        }
    });

    // For modifying properties of Report Builder
    $scope.reportBuilder = {
        setBuilderLoading: function setLoading(isLoading)
        {
            $('#loader').toggleClass('hide', !isLoading);
            $('#builder-container').toggleClass('hide', isLoading).removeAttr('style');
        },

        setBuilderName: function setBuilderName(newName)
        {
            if (typeof newName !== "string") return;

            $('#builder-name').html(newName)
        },

        loadReportLogTemplates: loadReportLogTemplates,
        refreshReportFilters: refreshReportFilters,

        initializedPromise: function()
        {
            return _initializationPromise.promise;
        }
    };

    if (typeof $scope.filterFromSubTemplate !== 'function')
        $scope.filterFromSubTemplate = function (segments, subTemplateId, emptyOnNoSub)
        {
            emptyOnNoSub = emptyOnNoSub || false;
            subTemplateId = (!isNaN(subTemplateId)) ? subTemplateId : ((subTemplateId && subTemplateId.id) ? subTemplateId.id : null );
            var startIndex = segments.findIndex(function(seg) { return seg.id == subTemplateId });
            if (!subTemplateId || (startIndex < 0)) return (emptyOnNoSub) ? [] : segments;

            var toReturn = [];
            for (var i = startIndex + 1; i < segments.length; i++)
            {
                var segment = segments[i];
                if (!segment || segment.type.id == 5)
                    break;

                toReturn.push(segment);
            }
            return toReturn;
        };
    
    initialize();
    
    return $builder;
};

/* Below override causes adding a group to not add a rule by default. 
   Taken from https://github.com/mistic100/jQuery-QueryBuilder/issues/425 */

// override addGroup to make addRule=undefined behaves like addRule=false
var _addGroup = $.fn.queryBuilder.constructor.prototype.addGroup;

$.fn.queryBuilder.constructor.prototype.addGroup = function(parent, addRule, data, flags) {
  return _addGroup.call(this, parent, addRule===true, data, flags);
};